import {c as cookieKeys,l as localStorageKeys,D as DEFAULT_DEADLINE,L as LIVE_STATISTICS_SUPPORTED_SPORTS,a as LIVE_STATISTICS_SUPPORTED_PROVIDERS}from'./config.js';import {jsx}from'react/jsx-runtime';import {createContext,useContext,useSyncExternalStore,useState,useEffect,useRef,useCallback,useMemo,useReducer}from'react';import {chainsData,ConditionsBatchDocument,getMaxBet,ConditionState,Bet_OrderBy,OrderDirection,GraphBetStatus,BetResult,SelectionResult,BetConditionStatus,GameState,SelectionKind,BetsDocument,GamesDocument,Legacy_Bet_OrderBy,LegacyGameStatus,LegacyBetsDocument,LegacyLiveGamesDocument,ConditionsDocument,GameDocument,groupConditionsByMarket,Game_OrderBy,SportsDocument,SportsNavigationDocument,NavigationDocument,getBetFee,BettorsDocument,ODDS_DECIMALS,GameBetsDocument,ConditionDocument,coreAbi,freeBetAbi,calcMindOdds,getComboBetTypedData,createComboBet,getBetTypedData,createBet,BetState,getBet,getProviderFromId,getPrecalculatedCashouts,getCalculatedCashout,getCashoutTypedData,createCashout,CashoutState,getCashout,getWaveLevels,getWaveStats,getWavePeriods,getWaveLeaderBoard,activateWave}from'@azuro-org/toolkit';import {useQueryClient,useQuery,useInfiniteQuery,useMutation}from'@tanstack/react-query';import {useAccount,useReadContract,useBalance,useConfig,useSendTransaction,useWaitForTransactionReceipt,useWalletClient,useWriteContract}from'wagmi';import {print,Kind}from'graphql';import {getMarketName,getSelectionName}from'@azuro-org/dictionaries';import {formatUnits,parseUnits,decodeEventLog,erc20Abi,encodeFunctionData,maxUint256}from'viem';import {waitForTransactionReceipt}from'wagmi/actions';import {gnosis,base,baseSepolia}from'viem/chains';var SportHub;
(function (SportHub) {
    SportHub["Sports"] = "sports";
    SportHub["Esports"] = "esports";
    SportHub["Unique"] = "unique";
})(SportHub || (SportHub = {}));
var BetType;
(function (BetType) {
    BetType["Unredeemed"] = "unredeemed";
    BetType["Accepted"] = "accepted";
    BetType["Settled"] = "settled";
    BetType["CashedOut"] = "cashedOut";
})(BetType || (BetType = {}));const DumbContext = createContext(undefined);
let ready = false;
let listeners = [];
const readyStore = {
    setReady(value = true) {
        ready = value;
        emitChange();
    },
    subscribe(listener) {
        listeners = [...listeners, listener];
        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    },
    getSnapshot() {
        return ready;
    },
};
const emitChange = () => {
    for (let listener of listeners) {
        listener();
    }
};
let useAccountWithAA = () => useContext(DumbContext);
let _useAAWalletClient = () => useContext(DumbContext);
const useExtendedAccount = () => {
    const account = useAccount();
    const ready = useSyncExternalStore(readyStore.subscribe, readyStore.getSnapshot, () => false);
    const accountWithAA = useAccountWithAA();
    return accountWithAA || { ...account, isAAWallet: false, ready };
};
const useAAWalletClient = () => {
    useSyncExternalStore(readyStore.subscribe, readyStore.getSnapshot, () => false);
    return _useAAWalletClient();
};
(async () => {
    try {
        const pkg = await import('@azuro-org/sdk-social-aa-connector');
        if (typeof pkg.useAccount === 'function') {
            useAccountWithAA = pkg.useAccount;
        }
        if (typeof pkg.useAAWalletClient === 'function') {
            _useAAWalletClient = pkg.useAAWalletClient;
        }
        readyStore.setReady();
    }
    catch (e) {
        readyStore.setReady();
    }
})();const ChainContext = createContext(null);
const useChain = () => {
    return useContext(ChainContext);
};
const ChainProvider = (props) => {
    const { children, initialChainId } = props;
    const [appChainId, setAppChainId] = useState(initialChainId);
    const { chain: walletChain, isAAWallet } = useExtendedAccount();
    const aaWalletClient = useAAWalletClient();
    useQueryClient();
    const walletChainId = walletChain?.id || null;
    const isRightNetwork = walletChainId === appChainId;
    const { chain, contracts, betToken, graphql, socket, api, environment } = chainsData[appChainId];
    const handleChangeChain = (chainId) => {
        document.cookie = `${cookieKeys.appChainId}=${chainId};path=/;`;
        setAppChainId(chainId);
    };
    useEffect(() => {
        if (isAAWallet && aaWalletClient && aaWalletClient.chain.id !== appChainId) {
            aaWalletClient.switchChain({ id: appChainId });
        }
    }, [isAAWallet, aaWalletClient, appChainId]);
    const context = {
        appChain: chain,
        walletChain,
        contracts,
        betToken,
        graphql,
        socket,
        api,
        environment,
        isRightNetwork,
        setAppChainId: handleChangeChain,
    };
    return (jsx(ChainContext.Provider, { value: context, children: children }));
};var SocketCloseReason$1;
(function (SocketCloseReason) {
    SocketCloseReason[SocketCloseReason["Unmount"] = 3000] = "Unmount";
})(SocketCloseReason$1 || (SocketCloseReason$1 = {}));
const FeedSocketContext = createContext(null);
const useFeedSocket = () => {
    return useContext(FeedSocketContext);
};
const FeedSocketProvider = ({ children }) => {
    const { socket: socketUrl } = useChain();
    const [socket, setSocket] = useState();
    const isSocketReady = socket?.readyState === WebSocket.OPEN;
    const prevSocketUrl = useRef(socketUrl);
    const isConnectedRef = useRef(false);
    const connect = () => {
        if (isConnectedRef.current) {
            return;
        }
        isConnectedRef.current = true;
        const newSocket = new WebSocket(`${socketUrl}/feed`);
        const handleOpen = () => {
            setSocket(newSocket);
        };
        const handleClose = (event) => {
            setSocket(undefined);
            isConnectedRef.current = false;
            newSocket.removeEventListener('open', handleOpen);
            newSocket.removeEventListener('close', handleClose);
            newSocket.removeEventListener('error', handleError);
            if (event.code !== SocketCloseReason$1.Unmount) {
                setTimeout(connect, 1000);
            }
        };
        const handleError = () => {
            isConnectedRef.current = false;
        };
        newSocket.addEventListener('open', handleOpen);
        newSocket.addEventListener('close', handleClose);
        newSocket.addEventListener('error', handleError);
    };
    useEffect(() => {
        connect();
        return () => {
            socket?.close(SocketCloseReason$1.Unmount);
        };
    }, []);
    useEffect(() => {
        if (!socket || !isSocketReady || prevSocketUrl.current === socketUrl) {
            return;
        }
        socket.close();
        prevSocketUrl.current = socketUrl;
    }, [socketUrl, isSocketReady]);
    const value = { socket, isSocketReady };
    return (jsx(FeedSocketContext.Provider, { value: value, children: children }));
};function debounce(func, wait, withMaxRequests) {
    let timeout;
    let requests = 0;
    return function (...args) {
        const context = this;
        const later = function () {
            timeout = undefined;
            requests = 0;
            func.apply(context, args);
        };
        if (withMaxRequests) {
            requests++;
        }
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        if (requests > 100) {
            later();
        }
        else {
            timeout = setTimeout(later, wait);
        }
    };
}const createQueueAction = (subscribe, unsubscribe) => {
    const actions = {
        subscribe: [],
        unsubscribe: [],
    };
    // group batch requests
    const request = debounce(() => {
        const subscribeQueue = [...actions.subscribe];
        const unsubscribeQueue = [...actions.unsubscribe];
        actions.subscribe = [];
        actions.unsubscribe = [];
        const weights = {};
        subscribeQueue.forEach(id => {
            if (!weights[id]) {
                weights[id] = 1;
            }
            else {
                weights[id]++;
            }
        });
        unsubscribeQueue.forEach(id => {
            if (!weights[id]) {
                weights[id] = -1;
            }
            else {
                weights[id]--;
            }
        });
        const { subscribeWeights, unsubscribeWeights } = Object.keys(weights).reduce((acc, id) => {
            // ATTN: equal cause we need to fire subscribe for new elements
            // and then trigger watcher (we don't have store)
            if (weights[id] > 0) {
                acc.subscribeWeights[id] = weights[id];
            }
            else if (weights[id] < 0) {
                acc.unsubscribeWeights[id] = weights[id];
            }
            return acc;
        }, {
            subscribeWeights: {},
            unsubscribeWeights: {},
        });
        if (Object.keys(subscribeWeights).length) {
            subscribe(subscribeWeights);
        }
        if (Object.keys(unsubscribeWeights).length) {
            unsubscribe(unsubscribeWeights);
        }
    }, 50);
    const run = (action, values) => {
        request();
        values.forEach(value => {
            actions[action].push(value);
        });
    };
    return run;
};const createWatcher = () => {
    const timers = new Map();
    const subscribers = new Map();
    const trigger = (key, value) => {
        const handlers = subscribers.get(key) || [];
        handlers.forEach((cb) => {
            cb(value);
        });
    };
    const subscribe = (key, cb) => {
        const handlers = subscribers.get(key) || [];
        handlers.push(cb);
        subscribers.set(key, handlers);
        return function unsubscribe() {
            const handlers = subscribers.get(key) || [];
            const newHandlers = handlers.filter((handler) => handler !== cb);
            if (newHandlers.length) {
                subscribers.set(key, newHandlers);
            }
            else {
                subscribers.delete(key);
            }
        };
    };
    const dispatch = (key, value) => {
        let timer = timers.get(key);
        if (timer !== undefined) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            timers.delete(key);
            trigger(key, value);
        }, 200);
        timers.set(key, timer);
    };
    return {
        subscribe,
        dispatch,
    };
};const conditionWatcher = createWatcher();const outcomeWatcher = createWatcher();var Event$1;
(function (Event) {
    Event["Subscribe"] = "SubscribeConditions";
    Event["Unsubscribe"] = "UnsubscribeConditions";
    Event["Update"] = "ConditionUpdated";
})(Event$1 || (Event$1 = {}));
const ConditionUpdatesContext = createContext(null);
const useConditionUpdates = () => {
    return useContext(ConditionUpdatesContext);
};
const ConditionUpdatesProvider = ({ children }) => {
    const { environment } = useChain();
    const { socket, isSocketReady } = useFeedSocket();
    const subscribers = useRef({});
    const subscribe = useCallback((weights) => {
        if (socket?.readyState !== 1) {
            return;
        }
        const newSubscribers = [];
        Object.keys(weights).forEach((conditionId) => {
            if (typeof subscribers.current[conditionId] === 'undefined') {
                newSubscribers.push(conditionId);
                subscribers.current[conditionId] = 0;
            }
            subscribers.current[conditionId] += weights[conditionId];
        });
        if (!newSubscribers.length) {
            return;
        }
        socket.send(JSON.stringify({
            event: Event$1.Subscribe,
            data: {
                conditionIds: Object.keys(weights),
                environment,
            },
        }));
    }, [socket, environment]);
    const unsubscribeCall = useCallback((conditionIds) => {
        if (socket?.readyState !== 1) {
            return;
        }
        socket.send(JSON.stringify({
            event: Event$1.Unsubscribe,
            data: {
                conditionIds,
                environment,
            },
        }));
    }, [socket, environment]);
    const unsubscribe = useCallback((weights) => {
        if (socket?.readyState !== 1) {
            return;
        }
        // we mustn't unsubscribe for condition if it has more that 1 subscriber
        const newUnsubscribers = [];
        Object.keys(weights).forEach((conditionId) => {
            if (subscribers.current[conditionId]) {
                subscribers.current[conditionId] += weights[conditionId];
                if (subscribers.current[conditionId] === 0) {
                    delete subscribers.current[conditionId];
                    newUnsubscribers.push(conditionId);
                }
            }
        });
        if (!newUnsubscribers.length) {
            return;
        }
        unsubscribeCall(newUnsubscribers);
    }, [socket, unsubscribeCall]);
    const runAction = useCallback(createQueueAction(subscribe, unsubscribe), [subscribe, unsubscribe]);
    const subscribeToUpdates = useCallback((conditionIds) => {
        runAction('subscribe', conditionIds);
    }, [runAction]);
    const unsubscribeToUpdates = useCallback((conditionIds) => {
        runAction('unsubscribe', conditionIds);
    }, [runAction]);
    useEffect(() => {
        if (!isSocketReady || !socket) {
            return;
        }
        const handleMessage = (message) => {
            const { event, data } = JSON.parse(message.data);
            if (event !== Event$1.Update) {
                return;
            }
            const { id: conditionId, outcomes, state } = data;
            const eventData = {
                conditionId: conditionId,
                state,
            };
            conditionWatcher.dispatch(conditionId, eventData);
            outcomes.forEach(({ outcomeId, currentOdds }) => {
                outcomeWatcher.dispatch(`${conditionId}-${outcomeId}`, {
                    odds: +currentOdds,
                });
            });
        };
        const handleClose = () => {
            subscribers.current = {};
        };
        socket.addEventListener('message', handleMessage);
        socket.addEventListener('close', handleClose);
        return () => {
            socket.removeEventListener('message', handleMessage);
            socket.removeEventListener('close', handleClose);
            if (socket.readyState !== WebSocket.OPEN) {
                subscribers.current = {};
            }
        };
    }, [socket]);
    const value = {
        isSocketReady,
        subscribeToUpdates,
        unsubscribeToUpdates,
    };
    return (jsx(ConditionUpdatesContext.Provider, { value: value, children: children }));
};const liveStatisticWatcher = createWatcher();var SocketCloseReason;
(function (SocketCloseReason) {
    SocketCloseReason[SocketCloseReason["Unmount"] = 3000] = "Unmount";
})(SocketCloseReason || (SocketCloseReason = {}));
var Status;
(function (Status) {
    Status["InProgress"] = "In progress";
    Status["NotStarted"] = "Not started yet";
    Status["Finished"] = "Finished";
    Status["PreFinished"] = "PreFinished";
    Status["CoverageLost"] = "Coverage lost";
    Status["Suspended"] = "Suspended";
})(Status || (Status = {}));
var SoccerIncidentType;
(function (SoccerIncidentType) {
    SoccerIncidentType["Goal"] = "goal";
    SoccerIncidentType["Corner"] = "corner";
    SoccerIncidentType["YellowCard"] = "yellow_card";
    SoccerIncidentType["RedCard"] = "red_card";
    SoccerIncidentType["Substitution"] = "substitution";
    SoccerIncidentType["GoalKick"] = "goal_kick";
    SoccerIncidentType["TrownIn"] = "throw_in";
    SoccerIncidentType["Penalty"] = "penalty";
    SoccerIncidentType["Offside"] = "offside";
    SoccerIncidentType["ScoreAfterFirstHalf"] = "score_after_first_half";
    SoccerIncidentType["ScoreAfterFullTime"] = "score_after_full_time";
    SoccerIncidentType["ScoreAfterExtraTime"] = "score_after_extra_time";
    SoccerIncidentType["ScoreAfterExtraTimeHalfTime"] = "score_after_extra_time_half_time";
    SoccerIncidentType["ScoreAfterPenalties"] = "score_after_penalties";
    SoccerIncidentType["ExtraTimeStart"] = "extra_time_start";
    SoccerIncidentType["PenaltiesStart"] = "penalties_start";
    SoccerIncidentType["PenaltyShootOut"] = "penalty_shoot_out";
    SoccerIncidentType["MissPenalty"] = "miss_penalty";
})(SoccerIncidentType || (SoccerIncidentType = {}));
var BasketballIncidentType;
(function (BasketballIncidentType) {
    BasketballIncidentType["MatchStart"] = "match_start";
    BasketballIncidentType["MatchEnd"] = "match_end";
    BasketballIncidentType["QuarterStart"] = "quarter_start";
    BasketballIncidentType["QuarterEnd"] = "quarter_end";
    BasketballIncidentType["Point"] = "point";
    BasketballIncidentType["FreeThrow"] = "free_throw";
    BasketballIncidentType["MissedThrow"] = "missed_throw";
    BasketballIncidentType["MissedFreeThrow"] = "missed_free_throw";
    BasketballIncidentType["PlayersOnCort"] = "players_on_cort";
    BasketballIncidentType["PlayersWarmingUp"] = "players_warming_up";
    BasketballIncidentType["Foul"] = "foul";
    BasketballIncidentType["Rebound"] = "rebound";
    BasketballIncidentType["Timeout"] = "timeout";
    BasketballIncidentType["TimeoutStart"] = "timeout_start";
    BasketballIncidentType["TimeoutEnd"] = "timeout_end";
    BasketballIncidentType["Turnover"] = "turnover";
    BasketballIncidentType["Block"] = "block";
    BasketballIncidentType["Steal"] = "steal";
    BasketballIncidentType["Halftime"] = "halftime";
    BasketballIncidentType["Fulltime"] = "fulltime";
    BasketballIncidentType["Overtime"] = "overtime";
    BasketballIncidentType["OvertimeStart"] = "overtime_start";
    BasketballIncidentType["OvertimeEnd"] = "overtime_end";
})(BasketballIncidentType || (BasketballIncidentType = {}));
var TennisIncidentType;
(function (TennisIncidentType) {
    TennisIncidentType["MatchStart"] = "match_start";
    TennisIncidentType["MatchEnd"] = "match_end";
    TennisIncidentType["SetStart"] = "set_start";
    TennisIncidentType["SetEnd"] = "set_end";
    TennisIncidentType["PlayersOnCort"] = "players_on_cort";
    TennisIncidentType["PlayersWarmingUp"] = "players_warming_up";
    TennisIncidentType["FirstServer"] = "first_server";
    TennisIncidentType["Service"] = "service";
    TennisIncidentType["Point"] = "point";
    TennisIncidentType["Game"] = "game";
    TennisIncidentType["Set"] = "set";
    TennisIncidentType["Fault"] = "fault";
})(TennisIncidentType || (TennisIncidentType = {}));
var VolleyballIncidentType;
(function (VolleyballIncidentType) {
    VolleyballIncidentType["MatchStart"] = "match_start";
    VolleyballIncidentType["MatchEnd"] = "match_end";
    VolleyballIncidentType["SetStart"] = "set_start";
    VolleyballIncidentType["SetEnd"] = "set_end";
    VolleyballIncidentType["FirstServer"] = "first_server";
    VolleyballIncidentType["Rally"] = "rally";
    VolleyballIncidentType["PointWon"] = "point_won";
    VolleyballIncidentType["ServiceError"] = "service_error";
    VolleyballIncidentType["Timeout"] = "timeout";
    VolleyballIncidentType["TimeoutStart"] = "timeout_start";
    VolleyballIncidentType["TimeoutEnd"] = "timeout_end";
    VolleyballIncidentType["Ace"] = "ace";
    VolleyballIncidentType["MatchDelay"] = "match_delay";
    VolleyballIncidentType["PlayersOnCort"] = "players_on_cort";
    VolleyballIncidentType["PlayersWarmingUp"] = "players_warming_up";
    VolleyballIncidentType["Service"] = "service";
})(VolleyballIncidentType || (VolleyballIncidentType = {}));
const LiveStatisticsSocketContext = createContext(null);
const useLiveStatisticsSocket = () => {
    return useContext(LiveStatisticsSocketContext);
};
const LiveStatisticsSocketProvider = ({ children }) => {
    const { socket: socketUrl } = useChain();
    const [socket, setSocket] = useState();
    const isSocketReady = socket?.readyState === WebSocket.OPEN;
    const isConnectedRef = useRef(false);
    const prevSocketUrl = useRef(socketUrl);
    const subscribers = useRef({});
    const subscribe = useCallback((weights) => {
        if (socket?.readyState !== 1) {
            return;
        }
        Object.keys(weights).forEach((gameId) => {
            if (typeof subscribers.current[gameId] === 'undefined') {
                subscribers.current[gameId] = 0;
            }
            subscribers.current[gameId] += weights[gameId];
        });
        socket.send(JSON.stringify({
            action: 'subscribe',
            gameIds: Object.keys(weights),
        }));
    }, [socket]);
    const unsubscribeCall = (gameIds) => {
        if (socket?.readyState !== 1) {
            return;
        }
        socket.send(JSON.stringify({
            action: 'unsubscribe',
            gameIds,
        }));
    };
    const unsubscribe = useCallback((weights) => {
        if (socket?.readyState !== 1) {
            return;
        }
        // we mustn't unsubscribe for condition if it has more that 1 subscriber
        const newUnsubscribers = [];
        Object.keys(weights).forEach((gameId) => {
            if (subscribers.current[gameId]) {
                subscribers.current[gameId] += weights[gameId];
                if (subscribers.current[gameId] === 0) {
                    delete subscribers.current[gameId];
                    newUnsubscribers.push(gameId);
                }
            }
        });
        if (!newUnsubscribers.length) {
            return;
        }
        unsubscribeCall(newUnsubscribers);
    }, [socket, unsubscribeCall]);
    const runAction = useCallback(createQueueAction(subscribe, unsubscribe), [subscribe, unsubscribe]);
    const subscribeToUpdates = useCallback((gameIds) => {
        runAction('subscribe', gameIds);
    }, [runAction]);
    const unsubscribeToUpdates = useCallback((gameIds) => {
        runAction('unsubscribe', gameIds);
    }, [runAction]);
    const connect = () => {
        if (isConnectedRef.current) {
            return;
        }
        isConnectedRef.current = true;
        const newSocket = new WebSocket(`${socketUrl}/statistics/games`);
        const handleOpen = () => {
            setSocket(newSocket);
        };
        const handleClose = (event) => {
            setSocket(undefined);
            isConnectedRef.current = false;
            newSocket.removeEventListener('open', handleOpen);
            newSocket.removeEventListener('message', handleMessage);
            newSocket.removeEventListener('close', handleClose);
            newSocket.removeEventListener('error', handleError);
            if (event.code !== SocketCloseReason.Unmount) {
                setTimeout(connect, 1000);
            }
        };
        const handleError = () => {
            isConnectedRef.current = false;
        };
        const handleMessage = (message) => {
            JSON.parse(message.data.toString()).forEach((data) => {
                const { id, fixture, live } = data;
                let statsData = {
                    status: fixture?.status || null,
                    scoreBoard: live?.scoreBoard || null,
                    stats: live?.stats || null,
                    virtualCourtId: fixture?.virtualCourtId || null,
                    timeline: live?.timeline || null,
                    jerseyColors: live?.jerseyColors || null,
                    clock: live?.clock || null,
                };
                liveStatisticWatcher.dispatch(id, statsData);
            });
        };
        newSocket.addEventListener('open', handleOpen);
        newSocket.addEventListener('message', handleMessage);
        newSocket.addEventListener('close', handleClose);
        newSocket.addEventListener('error', handleError);
    };
    useEffect(() => {
        connect();
        return () => {
            socket?.close();
        };
    }, []);
    useEffect(() => {
        if (!socket || !isSocketReady || prevSocketUrl.current === socketUrl) {
            return;
        }
        socket.close();
        prevSocketUrl.current = socketUrl;
    }, [socketUrl, isSocketReady]);
    const value = {
        isSocketReady,
        subscribeToUpdates,
        unsubscribeToUpdates,
    };
    return (jsx(LiveStatisticsSocketContext.Provider, { value: value, children: children }));
};const createBatch = (fn, isSet = true) => {
    let idsWaitList = isSet ? new Set() : [];
    let resolversWaitList = [];
    const request = debounce(async (fn, ...rest) => {
        const ids = [...idsWaitList];
        const resolvers = resolversWaitList;
        if (idsWaitList instanceof Set) {
            idsWaitList.clear();
        }
        else {
            idsWaitList = [];
        }
        resolversWaitList = [];
        try {
            const data = await fn(ids, ...rest);
            resolvers.forEach((resolve) => {
                resolve(data);
            });
        }
        catch (err) {
            resolvers.forEach((resolve) => {
                resolve(undefined);
            });
        }
    }, 50, true);
    const batch = (ids, ...rest) => {
        request(fn, ...rest);
        ids.forEach(id => {
            if (idsWaitList instanceof Set) {
                idsWaitList.add(id);
            }
            else {
                idsWaitList.push(id);
            }
        });
        return new Promise((resolve) => {
            resolversWaitList.push(resolve);
        });
    };
    return batch;
};const extractOperationName = (document) => {
    let operationName = undefined;
    const defs = document.definitions.filter((definition) => (typeof definition === 'object'
        && definition !== null
        && 'kind' in definition
        && definition.kind === Kind.OPERATION_DEFINITION));
    if (defs.length === 1) {
        operationName = defs[0].name?.value;
    }
    return operationName;
};
const gqlRequest = async (props) => {
    const { url, document, variables } = props;
    const opName = extractOperationName(document);
    const params = new URLSearchParams();
    if (opName) {
        params.append('op', opName);
    }
    if (variables && typeof variables === 'object' && 'limit' in variables) {
        params.append('limit', String(variables.limit));
    }
    if (variables && typeof variables === 'object' && 'offset' in variables) {
        params.append('offset', String(variables.offset));
    }
    const response = await fetch(`${url}?${params}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/graphql-response+json',
        },
        body: JSON.stringify({
            query: print(document),
            variables,
        }),
        cache: 'no-cache',
    });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const { data } = await response.json();
    return data;
};const getConditions = async (conditionEntityIds, gqlLink) => {
    const { conditions } = await gqlRequest({
        url: gqlLink,
        document: ConditionsBatchDocument,
        variables: {
            conditionFilter: {
                id_in: conditionEntityIds,
            },
        },
    });
    return conditions.reduce((acc, condition) => {
        const { conditionId, outcomes: _outcomes } = condition;
        const outcomes = _outcomes.reduce((acc, outcome) => {
            acc[outcome.outcomeId] = outcome;
            return acc;
        }, {});
        acc[conditionId] = {
            ...condition,
            outcomes,
        };
        return acc;
    }, {});
};
const batchFetchConditions = createBatch(getConditions);const formatToFixed = (value, digitsCount) => {
    value = String(value);
    if (!/\./.test(value)) {
        return value;
    }
    const [int, digits] = value.split('.');
    if (digitsCount === 0) {
        return int;
    }
    return `${int}.${digits.substring(0, digitsCount)}`;
};const useOdds = ({ selections }) => {
    const { graphql } = useChain();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useConditionUpdates();
    const [odds, setOdds] = useState({});
    const [isFetching, setFetching] = useState(true);
    const { selectionsKey, conditionsKey } = useMemo(() => (selections?.reduce((acc, { conditionId, outcomeId }) => {
        acc.selectionsKey += acc.selectionsKey ? `-${conditionId}/${outcomeId}` : `${conditionId}/${outcomeId}`;
        acc.conditionsKey += acc.conditionsKey ? `-${conditionId}` : `${conditionId}`;
        return acc;
    }, {
        selectionsKey: '',
        conditionsKey: '',
    })), [selections]);
    const prevSelectionsKeyRef = useRef(selectionsKey);
    if (selectionsKey !== prevSelectionsKeyRef.current) {
        setFetching(true);
        setOdds({});
    }
    prevSelectionsKeyRef.current = selectionsKey;
    const totalOdds = useMemo(() => {
        return +formatToFixed(Object.keys(odds).reduce((acc, key) => acc * +odds[key], 1), 5);
    }, [odds]);
    useEffect(() => {
        if (!isSocketReady) {
            return;
        }
        const conditionIds = conditionsKey.split('-');
        subscribeToUpdates(conditionIds);
        return () => {
            unsubscribeToUpdates(conditionIds);
        };
    }, [isSocketReady, conditionsKey]);
    useEffect(() => {
        const unsubscribeList = selections.map(({ conditionId, outcomeId }) => {
            return outcomeWatcher.subscribe(`${conditionId}-${outcomeId}`, (data) => {
                setOdds(prevOdds => ({
                    ...prevOdds,
                    [`${conditionId}-${outcomeId}`]: data.odds,
                }));
            });
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [selectionsKey]);
    useEffect(() => {
        const conditionIds = conditionsKey?.split('-');
        if (!conditionIds.length) {
            return;
        }
        (async () => {
            const data = await batchFetchConditions(conditionIds, graphql.feed);
            const newOdds = selections.reduce((acc, { conditionId, outcomeId }) => {
                acc[`${conditionId}-${outcomeId}`] = +(data[conditionId]?.outcomes[outcomeId]?.odds || 1);
                return acc;
            }, {});
            setOdds(newOdds);
            setFetching(false);
        })();
    }, [selectionsKey, graphql.feed]);
    return {
        data: {
            odds,
            totalOdds,
        },
        isFetching,
    };
};const useConditionsState = ({ conditionIds, initialStates }) => {
    const { graphql } = useChain();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useConditionUpdates();
    const [states, setStates] = useState(initialStates ?? {});
    const [isStatesFetching, setStatesFetching] = useState(!initialStates);
    const conditionsKey = useMemo(() => conditionIds.join('-'), [conditionIds]);
    const prevConditionsKeyRef = useRef(conditionsKey);
    if (conditionIds.length && conditionsKey !== prevConditionsKeyRef.current) {
        setStatesFetching(true);
        setStates({});
    }
    prevConditionsKeyRef.current = conditionsKey;
    useEffect(() => {
        if (!isSocketReady || !conditionsKey.length) {
            return;
        }
        subscribeToUpdates(conditionIds);
        return () => {
            unsubscribeToUpdates(conditionIds);
        };
    }, [conditionsKey, isSocketReady]);
    useEffect(() => {
        if (!conditionIds.length) {
            return;
        }
        const unsubscribeList = conditionIds.map((conditionId) => {
            return conditionWatcher.subscribe(conditionId, (data) => {
                const { state: newState } = data;
                setStates(states => ({
                    ...states,
                    [conditionId]: newState,
                }));
            });
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [conditionsKey]);
    useEffect(() => {
        if (!conditionIds.length || initialStates) {
            return;
        }
        (async () => {
            const data = await batchFetchConditions(conditionIds, graphql.feed);
            const newStatuses = (conditionIds || []).reduce((acc, conditionId) => {
                if (conditionId && data?.[conditionId]) {
                    acc[conditionId] = data[conditionId].state;
                }
                return acc;
            }, {});
            setStatesFetching(false);
            setStates(newStatuses);
        })();
    }, [conditionsKey]);
    return {
        data: states,
        isFetching: isStatesFetching,
    };
};const useForceUpdate = () => {
    const [increment, setState] = useState(0);
    const forceUpdate = useCallback(() => {
        setState((v) => ++v);
    }, []);
    return { increment, forceUpdate };
};const useMaxBet = (props) => {
    const { selections, query = {} } = props;
    const { appChain } = useChain();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useConditionUpdates();
    const selectionsKey = useMemo(() => (selections.map(({ conditionId, outcomeId }) => `${conditionId}/${outcomeId}`).join('-')), [selections]);
    const queryData = useQuery({
        queryKey: ['max-bet', appChain.id, selectionsKey],
        queryFn: async () => {
            const data = await getMaxBet({
                chainId: appChain.id,
                selections,
            });
            if (!data) {
                return '0';
            }
            return formatToFixed(data.maxBet, 3);
        },
        gcTime: 0, // disable cache
        refetchOnWindowFocus: false,
        enabled: Boolean(selections.length),
        ...query,
    });
    const { refetch } = queryData;
    useEffect(() => {
        if (!isSocketReady || !selections?.length) {
            return;
        }
        const conditionIds = selections.map(({ conditionId }) => conditionId);
        subscribeToUpdates(conditionIds);
        return () => {
            unsubscribeToUpdates(conditionIds);
        };
    }, [selectionsKey, isSocketReady]);
    useEffect(() => {
        if (!selections?.length) {
            return;
        }
        const unsubscribeList = selections.map(({ conditionId }) => {
            return conditionWatcher.subscribe(conditionId, () => refetch());
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [selectionsKey]);
    return queryData;
};var BetslipDisableReason;
(function (BetslipDisableReason) {
    BetslipDisableReason["ConditionState"] = "ConditionState";
    BetslipDisableReason["BetAmountGreaterThanMaxBet"] = "BetAmountGreaterThanMaxBet";
    BetslipDisableReason["BetAmountLowerThanMinBet"] = "BetAmountLowerThanMinBet";
    BetslipDisableReason["ComboWithForbiddenItem"] = "ComboWithForbiddenItem";
    BetslipDisableReason["ComboWithSameGame"] = "ComboWithSameGame";
    BetslipDisableReason["PrematchConditionInStartedGame"] = "PrematchConditionInStartedGame";
    BetslipDisableReason["FreeBetWithLive"] = "FreeBetWithLive";
    BetslipDisableReason["FreeBetWithCombo"] = "FreeBetWithCombo";
    // FreeBetWithBatch = 'FreeBetWithBatch',
    BetslipDisableReason["FreeBetExpired"] = "FreeBetExpired";
    BetslipDisableReason["FreeBetMinOdds"] = "FreeBetMinOdds";
})(BetslipDisableReason || (BetslipDisableReason = {}));
const BaseBetslipContext = createContext(null);
const DetailedBetslipContext = createContext(null);
const useBaseBetslip = () => {
    return useContext(BaseBetslipContext);
};
const useDetailedBetslip = () => {
    return useContext(DetailedBetslipContext);
};
const BetslipProvider = (props) => {
    const { children, affiliate } = props;
    const { appChain } = useChain();
    useExtendedAccount();
    const { forceUpdate } = useForceUpdate();
    const [items, setItems] = useState([]);
    const [selectedFreeBet, setFreeBet] = useState();
    const [betAmount, setBetAmount] = useState('');
    // const [ batchBetAmounts, setBatchBetAmounts ] = useState<Record<string, string>>({})
    // const [ isBatch, setBatch ] = useState(false)
    // TODO
    // const { data: freeBets, isFetching: isFreeBetsFetching } = useFreeBets({
    //   account: account.address!,
    //   affiliate: affiliate!,
    //   enabled: Boolean(affiliate),
    // })
    const { data: oddsData, isFetching: isOddsFetching } = useOdds({
        // betAmount,
        // batchBetAmounts,
        selections: items,
    });
    const { data: states, isFetching: isStatesFetching } = useConditionsState({
        conditionIds: items.map(({ conditionId }) => conditionId),
    });
    const { data: maxBet, isFetching: isMaxBetFetching } = useMaxBet({ selections: items });
    const { odds, totalOdds } = oddsData;
    const isCombo = items.length > 1;
    // const isCombo = !isBatch && items.length > 1
    const checkDifferentGames = (items) => {
        const gameIds = items.map(({ gameId }) => gameId);
        return gameIds.length === new Set(gameIds).size;
    };
    // const createInitialBatchAmounts = (items: AzuroSDK.BetslipItem[]) => {
    //   setBatchBetAmounts(batchAmounts => {
    //     const newBatchAmounts: Record<string, string> = {}
    //     items.forEach(({ conditionId, outcomeId }) => {
    //       const key = `${conditionId}-${outcomeId}`
    //       newBatchAmounts[key] = batchAmounts[key] || ''
    //     })
    //     return newBatchAmounts
    //   })
    // }
    const totalBetAmount = useMemo(() => {
        // if (isBatch) {
        //   return String(Object.values(batchBetAmounts).reduce((acc, amount) => acc + +amount, 0))
        // }
        if (selectedFreeBet) {
            return selectedFreeBet.amount;
        }
        return betAmount;
    }, 
    // [ isBatch, betAmount, batchBetAmounts, selectedFreeBet ]
    [betAmount, selectedFreeBet]);
    // const isLiveBet = useMemo(() => {
    //   return items.some(({ coreAddress }) => coreAddress === liveHostAddress)
    // }, [ items ])
    const isConditionsInActiveState = useMemo(() => {
        return Object.values(states).every(state => state === ConditionState.Active);
    }, [states]);
    const isComboWithDifferentGames = useMemo(() => {
        return !isCombo || checkDifferentGames(items);
    }, [isCombo, items]);
    // const isFreeBetAllowed = useMemo(() => {
    //   if (!selectedFreeBet || !totalOdds) {
    //     return true
    //   }
    //   return (
    //     !isCombo && !isBatch && !isLiveBet
    //     && selectedFreeBet.expiresAt > Date.now()
    //     && totalOdds >= parseFloat(selectedFreeBet.minOdds)
    //   )
    // }, [ selectedFreeBet, isCombo, isBatch, isLiveBet, totalOdds ])
    const isComboAllowed = useMemo(() => {
        return !isCombo || isComboWithDifferentGames && items.every(({ isExpressForbidden }) => !isExpressForbidden);
    }, [isCombo, items]);
    // const isPrematchBetAllowed = useMemo(() => {
    //   return items.every(({ game: { startsAt } }) => {
    //     return startsAt * 1000 > Date.now()
    //   })
    // }, [ items ])
    // const minBet = isLiveBet && !appChain?.testnet ? MIN_LIVE_BET_AMOUNT : undefined
    const minBet = undefined; // TODO
    const isAmountLowerThanMaxBet = Boolean(betAmount) && typeof maxBet !== 'undefined' ? +betAmount <= +maxBet : true;
    const isAmountBiggerThanMinBet = true;
    const isBetAllowed = (isConditionsInActiveState
        && isComboAllowed
        // && isPrematchBetAllowed
        // && isFreeBetAllowed
        && isAmountLowerThanMaxBet
        && isAmountBiggerThanMinBet);
    let disableReason = (() => {
        if (!isConditionsInActiveState) {
            return BetslipDisableReason.ConditionState;
        }
        // if (!isFreeBetAllowed) {
        //   if (isLiveBet) {
        //     return BetslipDisableReason.FreeBetWithLive
        //   }
        //   else {
        //     if (isCombo) {
        //       return BetslipDisableReason.FreeBetWithCombo
        //     }
        //     if (isBatch) {
        //       return BetslipDisableReason.FreeBetWithBatch
        //     }
        //   }
        //   if (selectedFreeBet!.expiresAt <= Date.now()) {
        //     return BetslipDisableReason.FreeBetExpired
        //   }
        //   if (totalOdds < parseFloat(selectedFreeBet!.minOdds)) {
        //     return BetslipDisableReason.FreeBetMinOdds
        //   }
        // }
        if (!isComboAllowed) {
            if (!isComboWithDifferentGames) {
                return BetslipDisableReason.ComboWithSameGame;
            }
            else {
                return BetslipDisableReason.ComboWithForbiddenItem;
            }
        }
        // if (!isPrematchBetAllowed) {
        //   return BetslipDisableReason.PrematchConditionInStartedGame
        // }
        if (!isAmountLowerThanMaxBet) {
            return BetslipDisableReason.BetAmountGreaterThanMaxBet;
        }
    })();
    // const changeBatch = useCallback((value: boolean) => {
    //   setBatch(value)
    //   if (value) {
    //     setBetAmount('')
    //     createInitialBatchAmounts(items)
    //   }
    //   else {
    //     setBatchBetAmounts({})
    //   }
    // }, [ items ])
    const changeBetAmount = useCallback((value) => {
        setBetAmount(value);
    }, []);
    // const changeBatchBetAmount = useCallback((item: ChangeBatchBetAmountItem, value: string) => {
    //   const { conditionId, outcomeId } = item
    //   const key = `${conditionId}-${outcomeId}`
    //   const decimals = ([ base.id, baseSepolia.id ] as number[]).includes(appChain.id) ? 4 : 2
    //   setBatchBetAmounts(amounts => {
    //     return {
    //       ...amounts,
    //       [key]: formatToFixed(value, decimals),
    //     }
    //   })
    // }, [ appChain ])
    const addItem = useCallback((item) => {
        setItems(items => {
            let newItems;
            const replaceIndex = items.findIndex(({ gameId }) => gameId === item.gameId);
            // if cart contains outcome from same game as new item
            // then replace old item
            if (replaceIndex !== -1) {
                // if (isBatchBetWithSameGameEnabled) {
                //   const { conditionId, outcomeId } = items[replaceIndex]!
                //   // if it's exactly the same outcome, don't change the state
                //   if (conditionId === item.conditionId && outcomeId === item.outcomeId) {
                //     return items
                //   }
                //   newItems = [ ...items, item ]
                //   setBatch(true)
                //   createInitialBatchAmounts(newItems)
                // }
                // else {
                newItems = [...items];
                newItems[replaceIndex] = item;
                // }
            }
            else {
                newItems = [...items, item];
            }
            localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify(newItems));
            // if (isBatch) {
            //   createInitialBatchAmounts(newItems)
            // }
            return newItems;
        });
    }, 
    // [ isBatch ]
    []);
    const removeItem = useCallback((itemProps) => {
        const { conditionId, outcomeId } = itemProps;
        setItems(items => {
            const newItems = items.filter((item) => !(item.conditionId === conditionId
                && item.outcomeId === outcomeId));
            // if (newItems.length < 2) {
            //   setBatch(false)
            // }
            // setBatchBetAmounts(batchAmounts => {
            //   if (newItems.length < 2) {
            //     const lastItem = newItems[0]
            //     if (lastItem) {
            //       const { conditionId, outcomeId } = lastItem
            //       const amount = batchAmounts[`${conditionId}-${outcomeId}`]
            //       if (amount) {
            //         setBetAmount(amount)
            //       }
            //     }
            //     return {}
            //   }
            //   const newBatchAmounts = { ...batchAmounts }
            //   delete newBatchAmounts[`${conditionId}-${outcomeId}`]
            //   return newBatchAmounts
            // })
            localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify(newItems));
            return newItems;
        });
    }, []);
    const clear = useCallback(() => {
        setItems([]);
        // setBatch(false)
        // setBatchBetAmounts({})
        setBetAmount('');
        setFreeBet(undefined);
        localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify([]));
    }, []);
    const prevChainId = useRef(appChain.id);
    useEffect(() => {
        if (prevChainId.current !== appChain.id) {
            clear();
            prevChainId.current = appChain.id;
        }
    }, [appChain.id]);
    useEffect(() => {
        let storedItems = JSON.parse(localStorage.getItem(localStorageKeys.betslipItems) || '[]');
        if (!Array.isArray(storedItems)) {
            return;
        }
        // const isDifferentGames = checkDifferentGames(storedItems)
        // if (!isDifferentGames) {
        //   setBatch(true)
        //   createInitialBatchAmounts(storedItems)
        // }
        setItems(storedItems);
    }, []);
    useEffect(() => {
        if (!selectedFreeBet || selectedFreeBet.expiresAt <= Date.now()) {
            return;
        }
        const timeout = setTimeout(() => {
            disableReason = BetslipDisableReason.FreeBetExpired;
            forceUpdate();
        }, selectedFreeBet.expiresAt - Date.now());
        return () => {
            clearTimeout(timeout);
        };
    }, [selectedFreeBet]);
    const baseValue = useMemo(() => ({
        items,
        addItem,
        removeItem,
        clear,
    }), [
        items,
        addItem,
        removeItem,
        clear,
    ]);
    const detailedValue = useMemo(() => ({
        betAmount: totalBetAmount,
        // batchBetAmounts,
        odds,
        totalOdds,
        maxBet: +(maxBet || 0),
        minBet,
        // selectedFreeBet,
        // freeBets,
        states,
        disableReason,
        changeBetAmount,
        // changeBatchBetAmount,
        // changeBatch,
        // selectFreeBet: setFreeBet,
        // isBatch,
        isStatesFetching,
        isOddsFetching,
        // isFreeBetsFetching,
        isMaxBetFetching,
        isBetAllowed,
    }), [
        totalBetAmount,
        // batchBetAmounts,
        odds,
        totalOdds,
        maxBet,
        minBet,
        // selectedFreeBet,
        // freeBets,
        states,
        disableReason,
        changeBetAmount,
        // changeBatchBetAmount,
        // changeBatch,
        // setFreeBet,
        // isBatch,
        isStatesFetching,
        isOddsFetching,
        // isFreeBetsFetching,
        isMaxBetFetching,
        isBetAllowed,
    ]);
    return (jsx(BaseBetslipContext.Provider, { value: baseValue, children: jsx(DetailedBetslipContext.Provider, { value: detailedValue, children: children }) }));
};const gameWathcer = createWatcher();var Event;
(function (Event) {
    Event["Subscribe"] = "SubscribeGames";
    Event["Unsubscribe"] = "UnsubscribeGames";
    Event["Update"] = "GameUpdated";
})(Event || (Event = {}));
const GameUpdatesContext = createContext(null);
const useGameUpdates = () => {
    return useContext(GameUpdatesContext);
};
const GameUpdatesProvider = ({ children }) => {
    const { environment } = useChain();
    const { socket, isSocketReady } = useFeedSocket();
    const subscribers = useRef({});
    const subscribe = useCallback((weights) => {
        if (socket?.readyState !== 1) {
            return;
        }
        const newSubscribers = [];
        Object.keys(weights).forEach((conditionId) => {
            if (typeof subscribers.current[conditionId] === 'undefined') {
                newSubscribers.push(conditionId);
                subscribers.current[conditionId] = 0;
            }
            subscribers.current[conditionId] += weights[conditionId];
        });
        if (!newSubscribers.length) {
            return;
        }
        socket.send(JSON.stringify({
            event: Event.Subscribe,
            data: {
                gameIds: Object.keys(weights),
                environment,
            },
        }));
    }, [socket, environment]);
    const unsubscribeCall = useCallback((gameIds) => {
        if (socket?.readyState !== 1) {
            return;
        }
        socket.send(JSON.stringify({
            event: Event.Unsubscribe,
            data: {
                gameIds,
                environment,
            },
        }));
    }, [socket, environment]);
    const unsubscribe = useCallback((weights) => {
        if (socket?.readyState !== 1) {
            return;
        }
        // we mustn't unsubscribe for condition if it has more that 1 subscriber
        const newUnsubscribers = [];
        Object.keys(weights).forEach((gameId) => {
            if (subscribers.current[gameId]) {
                subscribers.current[gameId] += weights[gameId];
                if (subscribers.current[gameId] === 0) {
                    delete subscribers.current[gameId];
                    newUnsubscribers.push(gameId);
                }
            }
        });
        if (!newUnsubscribers.length) {
            return;
        }
        unsubscribeCall(newUnsubscribers);
    }, [socket, unsubscribeCall]);
    const runAction = useCallback(createQueueAction(subscribe, unsubscribe), [subscribe, unsubscribe]);
    const subscribeToUpdates = useCallback((gameIds) => {
        runAction('subscribe', gameIds);
    }, [runAction]);
    const unsubscribeToUpdates = useCallback((gameIds) => {
        runAction('unsubscribe', gameIds);
    }, [runAction]);
    useEffect(() => {
        if (!isSocketReady || !socket) {
            return;
        }
        const handleMessage = (message) => {
            const { event, data } = JSON.parse(message.data);
            if (event !== Event.Update) {
                return;
            }
            const { id: gameId } = data;
            gameWathcer.dispatch(gameId, data);
        };
        const handleClose = () => {
            subscribers.current = {};
        };
        socket.addEventListener('message', handleMessage);
        socket.addEventListener('close', handleClose);
        return () => {
            socket.removeEventListener('message', handleMessage);
            socket.removeEventListener('close', handleClose);
            if (socket.readyState !== WebSocket.OPEN) {
                subscribers.current = {};
            }
        };
    }, [socket]);
    const value = {
        isSocketReady,
        subscribeToUpdates,
        unsubscribeToUpdates,
    };
    return (jsx(GameUpdatesContext.Provider, { value: value, children: children }));
};const AzuroSDKProvider = (props) => {
    const { children, initialChainId, affiliate } = props;
    return (jsx(ChainProvider, { initialChainId: initialChainId, children: jsx(FeedSocketProvider, { children: jsx(GameUpdatesProvider, { children: jsx(ConditionUpdatesProvider, { children: jsx(LiveStatisticsSocketProvider, { children: jsx(BetslipProvider
                        // isBatchBetWithSameGameEnabled={isBatchBetWithSameGameEnabled}
                        , { 
                            // isBatchBetWithSameGameEnabled={isBatchBetWithSameGameEnabled}
                            affiliate: affiliate, children: children }) }) }) }) }) }));
};const LiveContext = createContext(null);
const useLive = () => {
    return useContext(LiveContext);
};
const LiveProvider = (props) => {
    const { children, initialLiveState } = props;
    const [isLive, setLive] = useState(Boolean(initialLiveState));
    const handleChangeLive = (value) => {
        document.cookie = `${cookieKeys.live}=${value};path=/;`;
        setLive(value);
    };
    const value = {
        isLive,
        changeLive: handleChangeLive,
    };
    return (jsx(LiveContext.Provider, { value: value, children: children }));
};const useBets = (props) => {
    const { filter, itemsPerPage = 100, orderBy = Bet_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Asc, query, } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.bets;
    return useInfiniteQuery({
        queryKey: [
            'bets',
            gqlLink,
            filter.bettor,
            filter.type,
            filter.affiliate,
            itemsPerPage,
            orderBy,
            orderDir,
        ],
        queryFn: async ({ pageParam }) => {
            const variables = {
                first: itemsPerPage,
                skip: itemsPerPage * (pageParam - 1),
                orderBy,
                orderDirection: orderDir,
                where: {
                    actor: filter.bettor?.toLowerCase(),
                },
            };
            if (filter.type === BetType.Unredeemed) {
                variables.where.isRedeemable = true;
                variables.where.isCashedOut = false;
            }
            if (filter.type === BetType.Accepted) {
                variables.where.status = GraphBetStatus.Accepted;
                variables.where.isCashedOut = false;
            }
            if (filter.type === BetType.Settled) {
                variables.where.status_in = [GraphBetStatus.Resolved, GraphBetStatus.Canceled];
            }
            if (filter.type === BetType.CashedOut) {
                variables.where.isCashedOut = true;
            }
            if (filter.affiliate) {
                variables.where.affiliate = filter.affiliate;
            }
            const { v3Bets } = await gqlRequest({
                url: gqlLink,
                document: BetsDocument,
                variables,
            });
            if (!v3Bets?.length) {
                return {
                    bets: [],
                    nextPage: undefined,
                };
            }
            const gameIds = v3Bets.reduce((acc, { selections }) => {
                selections.forEach((selection) => {
                    const { outcome: { condition: { gameId } } } = selection;
                    acc.add(gameId);
                });
                return acc;
            }, new Set());
            const { games } = await gqlRequest({
                url: graphql.feed,
                document: GamesDocument,
                variables: {
                    first: 1000,
                    where: {
                        gameId_in: [...gameIds],
                    },
                },
            });
            const gameByGameId = games.reduce((acc, game) => {
                acc[game.gameId] = game;
                return acc;
            }, {});
            const bets = v3Bets.map((rawBet) => {
                const { tokenId, actor, status, amount, odds, settledOdds, createdAt, resolvedAt, result, affiliate, selections, cashout: _cashout, isCashedOut, payout: _payout, isRedeemed: _isRedeemed, isRedeemable, freebet, txHash, redeemedTxHash, core: { address: coreAddress, liquidityPool: { address: lpAddress, }, }, } = rawBet;
                const isWin = result === BetResult.Won;
                const isLose = result === BetResult.Lost;
                const isCanceled = status === GraphBetStatus.Canceled;
                // express bets have a specific feature - protocol redeems LOST expresses to release liquidity,
                // so we should validate it by "win"/"canceled" statuses
                const isRedeemed = (isWin || isCanceled) && _isRedeemed;
                const isFreebet = Boolean(freebet);
                const freebetId = freebet?.freebetId;
                const freebetContractAddress = freebet?.contractAddress;
                const payout = isRedeemable && isWin ? +_payout : null;
                const betDiff = isFreebet ? amount : 0; // for freebet we must exclude bonus value from possible win
                const totalOdds = settledOdds ? +settledOdds : +odds;
                const possibleWin = +amount * totalOdds - +betDiff;
                const cashout = isCashedOut ? _cashout?.payout : undefined;
                const outcomes = selections
                    .map((selection) => {
                    const { odds, result, conditionKind, outcome: { outcomeId, title: customSelectionName, condition: { conditionId, status: conditionStatus, title: customMarketName, gameId, wonOutcomeIds, }, }, } = selection;
                    const game = gameByGameId[gameId];
                    const isWin = result ? result === SelectionResult.Won : null;
                    const isLose = result ? result === SelectionResult.Lost : null;
                    const isCanceled = (conditionStatus === BetConditionStatus.Canceled
                        || game.state === GameState.Stopped);
                    const isLive = conditionKind === SelectionKind.Live;
                    const marketName = customMarketName && customMarketName !== 'null' ? customMarketName : getMarketName({ outcomeId });
                    const selectionName = customSelectionName && customSelectionName !== 'null' ? customSelectionName : getSelectionName({ outcomeId, withPoint: true });
                    return {
                        selectionName,
                        outcomeId,
                        conditionId,
                        coreAddress,
                        odds: +odds,
                        marketName,
                        wonOutcomeIds: wonOutcomeIds || null,
                        game,
                        isWin,
                        isLose,
                        isCanceled,
                        isLive,
                    };
                })
                    .sort((a, b) => +a.game.startsAt - +b.game.startsAt);
                const bet = {
                    actor: actor,
                    affiliate: affiliate,
                    tokenId,
                    freebetContractAddress: freebetContractAddress,
                    freebetId,
                    txHash: txHash,
                    redeemedTxHash: redeemedTxHash,
                    totalOdds,
                    status,
                    amount,
                    possibleWin,
                    payout,
                    createdAt: +createdAt,
                    resolvedAt: resolvedAt ? +resolvedAt : null,
                    cashout,
                    isWin,
                    isLose,
                    isRedeemable,
                    isRedeemed,
                    isCanceled,
                    isCashedOut,
                    coreAddress: coreAddress,
                    lpAddress: lpAddress,
                    outcomes,
                };
                return bet;
            });
            return {
                bets,
                nextPage: bets.length < itemsPerPage ? undefined : pageParam + 1,
            };
        },
        initialPageParam: 1,
        getNextPageParam: lastPage => lastPage.nextPage ?? undefined,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        ...(query || {}),
    });
};const useLegacyBets = (props) => {
    const { filter, itemsPerPage = 100, orderBy = Legacy_Bet_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Asc, query, } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.bets;
    return useInfiniteQuery({
        queryKey: [
            'legacy-bets',
            gqlLink,
            filter.bettor,
            filter.type,
            filter.affiliate,
            itemsPerPage,
            orderBy,
            orderDir,
        ],
        queryFn: async ({ pageParam }) => {
            const variables = {
                first: itemsPerPage,
                skip: itemsPerPage * (pageParam - 1),
                orderBy,
                orderDirection: orderDir,
                where: {
                    actor: filter.bettor?.toLowerCase(),
                },
            };
            if (filter.type === BetType.Unredeemed) {
                variables.where.isRedeemable = true;
                variables.where.isCashedOut = false;
            }
            if (filter.type === BetType.Accepted) {
                variables.where.status = GraphBetStatus.Accepted;
                variables.where.isCashedOut = false;
            }
            if (filter.type === BetType.Settled) {
                variables.where.status_in = [GraphBetStatus.Resolved, GraphBetStatus.Canceled];
            }
            if (filter.type === BetType.CashedOut) {
                variables.where.isCashedOut = true;
            }
            if (filter.affiliate) {
                variables.where.affiliate = filter.affiliate;
            }
            const { bets: prematchBets, liveBets } = await gqlRequest({
                url: gqlLink,
                document: LegacyBetsDocument,
                variables,
            });
            if (!prematchBets?.length && !liveBets?.length) {
                return {
                    bets: [],
                    nextPage: undefined,
                };
            }
            let liveGames;
            if (liveBets?.length) {
                const gameIds = liveBets.reduce((acc, { selections }) => {
                    selections.forEach((selection) => {
                        const { outcome: { condition: { gameId } } } = selection;
                        acc.add(gameId);
                    });
                    return acc;
                }, new Set());
                const { games } = await gqlRequest({
                    url: graphql.legacyLive,
                    document: LegacyLiveGamesDocument,
                    variables: {
                        first: 1000,
                        where: {
                            gameId_in: [...gameIds],
                        },
                    },
                });
                liveGames = games.reduce((acc, game) => {
                    acc[game.gameId] = game;
                    return acc;
                }, {});
            }
            const bets = [...(prematchBets || []), ...(liveBets || [])].map((rawBet) => {
                const { tokenId, actor, status, amount, odds, settledOdds, createdAt, resolvedAt, result, affiliate, selections, cashout: _cashout, isCashedOut, payout: _payout, isRedeemed: _isRedeemed, isRedeemable, txHash, redeemedTxHash, core: { address: coreAddress, liquidityPool: { address: lpAddress, }, }, } = rawBet;
                const { freebet } = rawBet;
                const isWin = result === BetResult.Won;
                const isLose = result === BetResult.Lost;
                const isCanceled = status === GraphBetStatus.Canceled;
                // express bets have a specific feature - protocol redeems LOST expresses to release liquidity,
                // so we should validate it by "win"/"canceled" statuses
                const isRedeemed = (isWin || isCanceled) && _isRedeemed;
                const isFreebet = Boolean(freebet);
                const freebetId = freebet?.freebetId;
                const freebetContractAddress = freebet?.contractAddress;
                const payout = isRedeemable && isWin ? +_payout : null;
                const betDiff = isFreebet ? amount : 0; // for freebet we must exclude bonus value from possible win
                const totalOdds = settledOdds ? +settledOdds : +odds;
                const possibleWin = +amount * totalOdds - +betDiff;
                const cashout = isCashedOut ? _cashout?.payout : undefined;
                const outcomes = selections
                    .map((selection) => {
                    const { odds, result, outcome: { outcomeId, condition: { conditionId, status: conditionStatus, wonOutcomeIds, }, }, } = selection;
                    const { outcome: { title: customSelectionName, condition: { title: customMarketName, game: prematchGame, }, }, } = selection;
                    const { outcome: { condition: { gameId: liveGameId } } } = selection;
                    const game = prematchGame || liveGames[liveGameId];
                    const isWin = result ? result === SelectionResult.Won : null;
                    const isLose = result ? result === SelectionResult.Lost : null;
                    const isCanceled = (conditionStatus === BetConditionStatus.Canceled
                        || game.status === LegacyGameStatus.Paused);
                    const isLive = !prematchGame;
                    const marketName = customMarketName && customMarketName !== 'null' ? customMarketName : getMarketName({ outcomeId });
                    const selectionName = customSelectionName && customSelectionName !== 'null' ? customSelectionName : getSelectionName({ outcomeId, withPoint: true });
                    return {
                        selectionName,
                        outcomeId,
                        conditionId,
                        coreAddress,
                        odds: +odds,
                        marketName,
                        wonOutcomeIds: wonOutcomeIds || null,
                        game: {
                            id: game.id,
                            gameId: game.gameId,
                            slug: game.slug ?? '',
                            title: game.title || '',
                            startsAt: game.startsAt,
                            state: GameState.Finished,
                            sport: {
                                ...game.sport,
                            },
                            league: game.league,
                            country: game.league.country,
                            participants: game.participants,
                            turnover: '0',
                        },
                        isWin,
                        isLose,
                        isCanceled,
                        isLive,
                    };
                })
                    .sort((a, b) => +a.game.startsAt - +b.game.startsAt);
                const bet = {
                    actor: actor,
                    affiliate: affiliate,
                    tokenId,
                    freebetContractAddress: freebetContractAddress,
                    freebetId,
                    txHash: txHash,
                    redeemedTxHash: redeemedTxHash,
                    totalOdds,
                    status,
                    amount,
                    possibleWin,
                    payout,
                    createdAt: +createdAt,
                    resolvedAt: resolvedAt ? +resolvedAt : null,
                    cashout,
                    isWin,
                    isLose,
                    isRedeemable,
                    isRedeemed,
                    isCanceled,
                    isCashedOut,
                    coreAddress: coreAddress,
                    lpAddress: lpAddress,
                    outcomes,
                };
                return bet;
            });
            return {
                bets,
                nextPage: bets.length < itemsPerPage ? undefined : pageParam + 1,
            };
        },
        initialPageParam: 1,
        getNextPageParam: lastPage => lastPage.nextPage ?? undefined,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        ...(query || {}),
    });
};const useConditions = (props) => {
    const { gameId, filter = {}, orderBy, orderDir, query = {} } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.feed;
    return useQuery({
        queryKey: [
            'conditions',
            gqlLink,
            gameId,
            orderBy,
            orderDir,
            filter,
        ],
        queryFn: async () => {
            const variables = {
                orderBy,
                orderDirection: orderDir,
                where: {
                    ...filter,
                    game_: {
                        gameId,
                    },
                },
            };
            const { conditions } = await gqlRequest({
                url: gqlLink,
                document: ConditionsDocument,
                variables,
            });
            return conditions;
        },
        refetchOnWindowFocus: false,
        ...query,
    });
};const useActiveConditions = (props) => {
    const { gameId, filter = {}, query = {} } = props;
    const conditionsFilter = useMemo(() => {
        const _filter = {
            state_in: [ConditionState.Active, ConditionState.Stopped],
        };
        if (filter.outcomeIds) {
            _filter.outcomesIds_contains = filter.outcomeIds;
        }
        if (filter.maxMargin) {
            _filter.margin_lte = String(filter.maxMargin);
        }
        return _filter;
    }, [filter.outcomeIds, filter.maxMargin]);
    return useConditions({
        gameId,
        filter: conditionsFilter,
        query,
    });
};const useGame = (props) => {
    const { gameId, query = {} } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.feed;
    return useQuery({
        queryKey: [
            'game',
            gqlLink,
            gameId,
        ],
        queryFn: async () => {
            const variables = {
                id: gameId,
            };
            const { game } = await gqlRequest({
                url: gqlLink,
                document: GameDocument,
                variables,
            });
            return game;
        },
        refetchOnWindowFocus: false,
        ...query,
    });
};const useActiveMarkets = (props) => {
    const { gameId, filter, query: queryProps } = props;
    const query = useActiveConditions({
        gameId,
        filter,
        query: queryProps,
    });
    const { data: conditions, ...rest } = query;
    const conditionIds = conditions?.map(({ id, outcomes }) => `${id}-${outcomes.length}`).join('_');
    const markets = useMemo(() => {
        if (!conditions?.length) {
            return [];
        }
        return groupConditionsByMarket(conditions);
    }, [conditionIds]);
    return {
        data: markets,
        ...rest,
    };
};const useResolvedMarkets = (props) => {
    const { gameId } = props;
    const { data: conditions, ...rest } = useConditions({
        gameId,
        filter: {
            state: ConditionState.Resolved,
        },
    });
    const conditionIds = conditions?.map(({ id, outcomes }) => `${id}-${outcomes.length}`).join('_');
    const markets = useMemo(() => {
        if (!conditions?.length) {
            return [];
        }
        return groupConditionsByMarket(conditions);
    }, [conditionIds]);
    return {
        data: markets,
        ...rest,
    };
};const useGames = (props = {}) => {
    const { filter = {}, orderBy = Game_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Desc, isLive, query = {}, } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.feed;
    return useQuery({
        queryKey: [
            'games',
            gqlLink,
            isLive,
            filter.limit,
            filter.offset,
            filter.sportHub,
            filter.sportSlug,
            filter.sportIds?.join('-'),
            filter.leagueSlug,
            filter.maxMargin,
            filter.conditionsState,
            orderBy,
            orderDir,
        ],
        queryFn: async () => {
            const variables = {
                first: 1000,
                orderBy,
                orderDirection: orderDir,
                where: {
                    state: isLive ? GameState.Live : GameState.Prematch,
                    activeAndStoppedConditionsCount_not: 0,
                    conditions_: {},
                    sport_: {},
                    league_: {},
                },
            };
            if (isLive) {
                variables.where.activeAndStoppedConditionsCount_not = 0;
            }
            else {
                variables.where.activeConditionsCount_not = 0;
            }
            if (filter.limit) {
                variables.first = filter.limit;
            }
            if (filter.offset) {
                variables.skip = filter.offset;
            }
            if (filter.sportHub) {
                variables.where.sport_.sporthub = filter.sportHub;
            }
            if (filter.sportSlug) {
                variables.where.sport_.slug_starts_with_nocase = filter.sportSlug;
            }
            if (filter.sportIds?.length) {
                variables.where.sport_.sportId_in = filter?.sportIds;
            }
            if (filter.leagueSlug) {
                variables.where.league_.slug_in = typeof filter.leagueSlug === 'string' ? [filter.leagueSlug] : filter.leagueSlug;
            }
            if (filter.maxMargin) {
                variables.where.conditions_.margin_lte = String(filter.maxMargin);
            }
            if (filter.conditionsState) {
                if (typeof filter.conditionsState === 'string') {
                    variables.where.conditions_.state = filter.conditionsState;
                }
                else {
                    variables.where.conditions_.state_in = filter.conditionsState;
                }
            }
            const { games } = await gqlRequest({
                url: gqlLink,
                document: GamesDocument,
                variables,
            });
            return games;
        },
        refetchOnWindowFocus: false,
        ...query,
    });
};const useSports = (props = {}) => {
    const { filter = {}, gameOrderBy = Game_OrderBy.StartsAt, orderDir = OrderDirection.Asc, isLive, query = {}, } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.feed;
    const formatData = useCallback((data) => {
        const filteredSports = data.map(sport => {
            const { countries } = sport;
            const filteredCountries = countries.map((country) => {
                return {
                    ...country,
                    leagues: country.leagues.filter((league) => league.games.length),
                };
            }).filter((country) => country.leagues.length);
            return {
                ...sport,
                countries: filteredCountries,
            };
        }).filter(sport => sport.countries.length);
        if (gameOrderBy === Game_OrderBy.Turnover) {
            return filteredSports.sort((a, b) => +b.turnover - +a.turnover);
        }
        if (gameOrderBy === Game_OrderBy.StartsAt) {
            return filteredSports.map(sport => {
                const { countries } = sport;
                const sortedCountries = countries.map(country => {
                    const { leagues } = country;
                    return {
                        ...country,
                        leagues: [...leagues].sort((a, b) => +a.games[0].startsAt - +b.games[0].startsAt),
                    };
                }).sort((a, b) => +a.leagues[0].games[0].startsAt - +b.leagues[0].games[0].startsAt);
                return {
                    ...sport,
                    countries: sortedCountries,
                };
            }).sort((a, b) => +a.countries[0].leagues[0].games[0].startsAt - +b.countries[0].leagues[0].games[0].startsAt);
        }
    }, []);
    return useQuery({
        queryKey: [
            'sports',
            isLive,
            gqlLink,
            gameOrderBy,
            orderDir,
            filter.limit,
            filter.sportHub,
            filter.sportSlug,
            filter.countrySlug,
            filter.leagueSlug,
            filter.sportIds?.join('-'),
        ],
        queryFn: async () => {
            const variables = {
                first: filter.limit ?? 1000,
                sportFilter: {},
                countryFilter: {},
                leagueFilter: {},
                gameFilter: {
                    state: isLive ? GameState.Live : GameState.Prematch,
                },
                gameOrderBy,
                gameOrderDirection: orderDir,
            };
            if (isLive) {
                variables.sportFilter.activeLiveGamesCount_not = 0;
                variables.countryFilter.activeLiveGamesCount_not = 0;
                variables.leagueFilter.activeLiveGamesCount_not = 0;
                variables.gameFilter.activeAndStoppedConditionsCount_not = 0;
            }
            else {
                variables.sportFilter.activePrematchGamesCount_not = 0;
                variables.countryFilter.activePrematchGamesCount_not = 0;
                variables.leagueFilter.activePrematchGamesCount_not = 0;
                variables.gameFilter.activeConditionsCount_not = 0;
            }
            if (filter.sportSlug) {
                variables.sportFilter.slug = filter.sportSlug;
            }
            if (filter.sportHub) {
                variables.sportFilter.sporthub = filter.sportHub;
            }
            if (filter.sportIds?.length) {
                variables.sportFilter.sportId_in = filter.sportIds;
            }
            if (filter.countrySlug) {
                variables.countryFilter.slug = filter.countrySlug;
            }
            if (filter.leagueSlug) {
                variables.leagueFilter.slug = filter.leagueSlug;
            }
            const { sports } = await gqlRequest({
                url: gqlLink,
                document: SportsDocument,
                variables,
            });
            return sports;
        },
        select: formatData,
        refetchOnWindowFocus: false,
        ...query,
    });
};const useSportsNavigation = (props = {}) => {
    const { filter = {}, isLive, query = {} } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.feed;
    return useQuery({
        queryKey: [
            'sports-navigation',
            gqlLink,
            isLive,
            filter.sportHub,
            filter.sportIds?.join('-'),
        ],
        queryFn: async () => {
            const variables = {
                sportFilter: {},
            };
            if (isLive) {
                variables.sportFilter.activeLiveGamesCount_not = 0;
            }
            else {
                variables.sportFilter.activePrematchGamesCount_not = 0;
            }
            if (filter.sportHub) {
                variables.sportFilter.sporthub = filter.sportHub;
            }
            if (filter.sportIds?.length) {
                variables.sportFilter.sportId_in = filter.sportIds;
            }
            const { sports } = await gqlRequest({
                url: gqlLink,
                document: SportsNavigationDocument,
                variables,
            });
            return sports;
        },
        refetchOnWindowFocus: false,
        ...query,
    });
};const useNavigation = (props = {}) => {
    const { filter = {}, isLive, query = {} } = props;
    const { graphql } = useChain();
    const gqlLink = graphql.feed;
    return useQuery({
        queryKey: [
            'navigation',
            gqlLink,
            isLive,
            filter.sportHub,
            filter.sportIds?.join('-'),
        ],
        queryFn: async () => {
            const variables = {
                sportFilter: {},
                countryFilter: {},
                leagueFilter: {},
            };
            if (isLive) {
                variables.countryFilter.activeLiveGamesCount_not = 0;
                variables.leagueFilter.activeLiveGamesCount_not = 0;
            }
            else {
                variables.countryFilter.activePrematchGamesCount_not = 0;
                variables.leagueFilter.activePrematchGamesCount_not = 0;
            }
            if (filter.sportHub) {
                variables.sportFilter.sporthub = filter.sportHub;
            }
            if (filter.sportIds?.length) {
                variables.sportFilter.sportId_in = filter.sportIds;
            }
            const { sports } = await gqlRequest({
                url: gqlLink,
                document: NavigationDocument,
                variables,
            });
            return sports;
        },
        refetchOnWindowFocus: false,
        ...query,
    });
};const useBetFee = (props = {}) => {
    const { enabled = true, query = {} } = props;
    const { appChain } = useChain();
    const queryFn = async () => {
        const { gasAmount, relayerFeeAmount, beautyRelayerFeeAmount, } = await getBetFee(appChain.id);
        return {
            gasAmount: BigInt(gasAmount),
            relayerFeeAmount: BigInt(relayerFeeAmount),
            formattedRelayerFeeAmount: beautyRelayerFeeAmount,
        };
    };
    let { data, ...rest } = useQuery({
        queryKey: ['/bet-fee', appChain.id],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
        refetchInterval: 10_000,
        ...query,
    });
    if (!enabled) {
        data = undefined;
    }
    return {
        data,
        ...rest,
    };
};const useBetsSummary = (props) => {
    const { account, affiliates, query = {} } = props;
    const { betToken, graphql } = useChain();
    const gqlLink = graphql.bets;
    const formatData = useCallback((data) => {
        if (!data?.length) {
            return {
                toPayout: '0',
                inBets: '0',
                totalPayout: '0',
                totalProfit: '0',
                betsCount: 0,
                wonBetsCount: 0,
                lostBetsCount: 0,
            };
        }
        const { rawToPayout, rawInBets, rawTotalPayout, rawTotalProfit, betsCount, wonBetsCount, lostBetsCount, } = data.reduce((acc, bettor) => {
            const { rawToPayout, rawInBets, rawTotalPayout, rawTotalProfit, betsCount, wonBetsCount, lostBetsCount } = bettor;
            acc.rawToPayout += BigInt(rawToPayout);
            acc.rawInBets += BigInt(rawInBets);
            acc.rawTotalPayout += BigInt(rawTotalPayout);
            acc.rawTotalProfit += BigInt(rawTotalProfit);
            acc.betsCount += betsCount;
            acc.wonBetsCount += wonBetsCount;
            acc.lostBetsCount += lostBetsCount;
            return acc;
        }, {
            rawToPayout: 0n,
            rawInBets: 0n,
            rawTotalPayout: 0n,
            rawTotalProfit: 0n,
            betsCount: 0,
            wonBetsCount: 0,
            lostBetsCount: 0,
        });
        return {
            toPayout: formatUnits(rawToPayout, betToken.decimals),
            inBets: formatUnits(rawInBets, betToken.decimals),
            totalPayout: formatUnits(rawTotalPayout, betToken.decimals),
            totalProfit: formatUnits(rawTotalProfit, betToken.decimals),
            betsCount,
            wonBetsCount,
            lostBetsCount,
        };
    }, []);
    return useQuery({
        queryKey: [
            'bets-summary',
            gqlLink,
            account,
            affiliates?.join('-'),
        ],
        queryFn: async () => {
            const variables = {
                where: {
                    address: account?.toLowerCase(),
                },
            };
            if (affiliates?.length) {
                variables.where.affiliate_in = affiliates.map(affiliate => affiliate.toLowerCase());
            }
            const { bettors } = await gqlRequest({
                url: gqlLink,
                document: BettorsDocument,
                variables,
            });
            return bettors;
        },
        select: formatData,
        refetchOnWindowFocus: false,
        ...query,
    });
};const DIVIDER = 18;
const RAW_ONE = parseUnits('1', ODDS_DECIMALS);
const useBetsSummaryBySelection = (props) => {
    const { account, gameId, gameState, keyStruct = 'outcomeId', query = {} } = props;
    const { betToken, graphql } = useChain();
    const gqlLink = graphql.bets;
    const formatData = useCallback(({ bets: prematchBets, liveBets, v3Bets }) => {
        const rawSummary = [...(prematchBets || []), ...(liveBets || []), ...(v3Bets || [])].reduce((acc, bet) => {
            const { rawAmount: _rawAmount, rawPotentialPayout: _rawPotentialPayout, result, selections, isCashedOut } = bet;
            const { freebet } = bet;
            if (isCashedOut || !result) {
                return acc;
            }
            const isExpress = selections.length > 1;
            const isWin = result === BetResult.Won;
            const rawAmount = BigInt(_rawAmount);
            const rawBetDiff = freebet ? rawAmount : 0n;
            const rawPayout = BigInt(_rawPotentialPayout) - rawBetDiff;
            let rawOddsSummary = 0n;
            if (isExpress) {
                selections.forEach(selection => {
                    const { rawOdds } = selection;
                    rawOddsSummary += BigInt(rawOdds) - RAW_ONE;
                });
            }
            selections.forEach(selection => {
                const { outcome: { outcomeId, condition: { conditionId } } } = selection;
                if (isExpress) {
                    const _gameId = (selection.outcome.condition?.game?.gameId) || (selection.outcome.condition?.gameId);
                    if (gameId !== _gameId) {
                        return;
                    }
                }
                let key = outcomeId;
                if (keyStruct === 'conditionId-outcomeId') {
                    key = `${conditionId}-${outcomeId}`;
                }
                if (!acc[key]) {
                    acc[key] = 0n;
                }
                if (isExpress) {
                    const { rawOdds: _rawOdds } = selection;
                    const rawOdds = BigInt(_rawOdds);
                    const rawSubBetOdds = parseUnits(String(rawOdds - RAW_ONE), DIVIDER);
                    const rawPartialOdds = rawSubBetOdds / rawOddsSummary / BigInt(10 ** (DIVIDER - ODDS_DECIMALS));
                    const rawSubBetAmount = rawAmount * rawPartialOdds / BigInt(10 ** ODDS_DECIMALS);
                    if (isWin) {
                        acc[key] += rawSubBetAmount * rawOdds / BigInt(10 ** ODDS_DECIMALS);
                    }
                    else {
                        acc[key] -= rawSubBetAmount;
                    }
                }
                else {
                    acc[key] += isWin ? rawPayout : -rawAmount;
                }
            });
            return acc;
        }, {});
        return Object.keys(rawSummary).reduce((acc, key) => {
            acc[key] = formatUnits(rawSummary[key], betToken.decimals);
            return acc;
        }, {});
    }, []);
    return useQuery({
        queryKey: [
            'bets-summary-by-selection',
            gqlLink,
            account,
            gameId,
        ],
        queryFn: async () => {
            const variables = {
                actor: account?.toLowerCase(),
                gameId,
            };
            const data = await gqlRequest({
                url: gqlLink,
                document: GameBetsDocument,
                variables,
            });
            return data;
        },
        enabled: Boolean(account) && gameState === GameState.Finished,
        refetchOnWindowFocus: false,
        select: formatData,
        ...query,
    });
};const getEventArgsFromTxReceipt = ({ receipt, eventName, abi, params }) => {
    const { logs } = receipt;
    let result;
    for (let index = 0; index < logs.length; index++) {
        try {
            const log = logs[index];
            result = decodeEventLog({
                abi,
                topics: log.topics,
                eventName,
                data: log.data,
            });
            if (result.eventName.toLowerCase() !== eventName.toLowerCase()) {
                result = undefined;
                continue;
            }
            if (params && result?.args) {
                const isMatchByParams = Object.keys(params).every(paramKey => {
                    const argsParam = typeof params[paramKey] === 'string' ? (result.args[paramKey]?.toLowerCase()) : (result.args[paramKey]);
                    const paramsParam = typeof params[paramKey] === 'string' ? (params[paramKey].toLowerCase()) : (params[paramKey]);
                    return argsParam === paramsParam;
                });
                if (!isMatchByParams) {
                    result = undefined;
                }
            }
            if (result) {
                break;
            }
        }
        catch { }
    }
    if (result?.args) {
        return result?.args;
    }
};const useBetsCache = () => {
    const queryClient = useQueryClient();
    const { contracts, betToken, graphql } = useChain();
    const { address } = useExtendedAccount();
    const updateBetCache = (tokenId, values, isLegacy) => {
        let cachedBet;
        const betsKey = isLegacy ? 'legacy-bets' : 'bets';
        queryClient.setQueriesData({
            predicate: ({ queryKey }) => (queryKey[0] === betsKey &&
                queryKey[1] === graphql.bets &&
                String(queryKey[2]).toLowerCase() === address.toLowerCase()),
        }, (data) => {
            if (!data) {
                return data;
            }
            const { pages, pageParams } = data;
            const newPages = pages.map(page => {
                const { bets, nextPage } = page;
                return {
                    nextPage,
                    bets: bets.map(bet => {
                        if (bet.tokenId === tokenId) {
                            cachedBet = {
                                ...bet,
                                ...values,
                            };
                            return cachedBet;
                        }
                        return bet;
                    }),
                };
            });
            return {
                pages: newPages,
                pageParams,
            };
        });
        if (!values.isCashedOut && !cachedBet?.payout && !cachedBet?.isCanceled) {
            return;
        }
        queryClient.setQueriesData({
            predicate: ({ queryKey }) => (queryKey[0] === 'bets-summary' &&
                queryKey[1] === graphql.bets &&
                String(queryKey[2]).toLowerCase() === address.toLowerCase()),
        }, (oldData) => {
            if (!oldData) {
                return oldData;
            }
            const newData = [...oldData];
            const bettorIndex = newData.findIndex(({ id }) => id.split('_')[0]?.toLowerCase() === contracts.lp.address.toLowerCase());
            if (bettorIndex === -1) {
                return oldData;
            }
            const bettor = { ...newData[bettorIndex] };
            if (cachedBet.payout || cachedBet.isCanceled) {
                const rawAmount = cachedBet.isCanceled ? cachedBet.amount : cachedBet.payout;
                const rawPayout = parseUnits(String(rawAmount), betToken.decimals);
                const newRawToPayout = BigInt(bettor.rawToPayout) - rawPayout;
                bettor.rawToPayout = String(newRawToPayout);
            }
            if (values.isCashedOut) {
                const rawAmount = parseUnits(cachedBet.amount, betToken.decimals);
                bettor.rawInBets = String(BigInt(bettor.rawInBets) - rawAmount);
                bettor.betsCount -= 1;
            }
            newData[bettorIndex] = bettor;
            return newData;
        });
    };
    const addBet = async (props) => {
        const { bet, odds, affiliate, receipt } = props;
        const { rawAmount, selections, freebetId } = bet;
        const outcomes = [];
        const receiptArgs = getEventArgsFromTxReceipt({ receipt, eventName: 'NewLiveBet', abi: coreAbi });
        if (!receiptArgs) {
            return;
        }
        const conditions = queryClient.getQueryData(['conditions', graphql.feed]);
        for (let index = 0; index < selections.length; index++) {
            const { outcomeId, conditionId } = selections[index];
            let condition = conditions?.find((condition) => condition.conditionId === conditionId);
            if (!condition) {
                const { condition: _condition } = await gqlRequest({
                    url: graphql.feed,
                    document: ConditionDocument,
                    variables: {
                        id: conditionId,
                    },
                });
                condition = _condition;
            }
            const gameId = condition.game.gameId;
            let game = queryClient.getQueryData(['game', graphql.feed, gameId]);
            if (!game) {
                const { game: _game } = await gqlRequest({
                    url: graphql.feed,
                    document: GameDocument,
                    variables: {
                        id: gameId,
                    },
                });
                game = _game;
            }
            const { title: customMarketName } = condition;
            const { title: customSelectionName } = condition.outcomes.find(outcome => outcome.outcomeId === outcomeId);
            const selectionName = customSelectionName && customSelectionName !== 'null' ? customSelectionName : getSelectionName({ outcomeId, withPoint: true });
            const marketName = customMarketName && customMarketName !== 'null' ? customMarketName : getMarketName({ outcomeId });
            const eventOutcome = receiptArgs.betDatas.find(({ conditionId: rawConditionId, outcomeId: rawOutcomeId }) => (rawConditionId === BigInt(conditionId) && rawOutcomeId === BigInt(outcomeId)));
            outcomes.push({
                selectionName,
                outcomeId,
                conditionId,
                odds: +(odds[`${conditionId}-${outcomeId}`] || 1),
                marketName,
                wonOutcomeIds: null,
                game,
                isWin: false,
                isLose: false,
                isCanceled: false,
                isLive: eventOutcome.conditionKind === 1,
            });
        }
        const tokenId = (receiptArgs?.tokenId).toString();
        const rawOdds = receiptArgs.betDatas.reduce((acc, { odds }) => {
            acc *= odds;
            return acc;
        }, 1n);
        const rawPotentialPayout = rawAmount * rawOdds;
        const potentialPayout = formatUnits(rawPotentialPayout, ODDS_DECIMALS * receiptArgs.betDatas.length + betToken.decimals);
        const finalOdds = formatUnits(rawOdds, ODDS_DECIMALS * receiptArgs.betDatas.length);
        const amount = formatUnits(rawAmount, betToken.decimals);
        const isFreebet = Boolean(bet.freebetId);
        queryClient.setQueriesData({
            predicate: ({ queryKey }) => (queryKey[0] === 'bets' &&
                queryKey[1] === graphql.bets &&
                String(queryKey[2]).toLowerCase() === address.toLowerCase() &&
                (queryKey[3] === BetType.Accepted || typeof queryKey[3] === 'undefined')),
        }, (data) => {
            if (!data) {
                return data;
            }
            const { pages, pageParams } = data;
            const newBet = {
                actor: address,
                affiliate,
                tokenId,
                freebetContractAddress: bet.freebetContractAddress,
                freebetId: bet.freebetId,
                txHash: receipt.transactionHash,
                redeemedTxHash: null,
                totalOdds: +finalOdds,
                status: GraphBetStatus.Accepted,
                amount,
                possibleWin: +potentialPayout - (isFreebet ? +amount : 0),
                payout: null,
                createdAt: Math.floor(Date.now() / 1000),
                resolvedAt: null,
                cashout: undefined,
                isWin: false,
                isLose: false,
                isRedeemable: false,
                isRedeemed: false,
                isCanceled: false,
                isCashedOut: false,
                coreAddress: contracts.core.address,
                lpAddress: contracts.lp.address,
                outcomes,
            };
            const newPage = {
                bets: [newBet, ...pages[0].bets],
                nextPage: pages[0].nextPage,
            };
            return {
                pages: [newPage, ...pages.slice(1)],
                pageParams,
            };
        });
        queryClient.setQueriesData({
            predicate: ({ queryKey }) => (queryKey[0] === 'bets-summary' &&
                queryKey[1] === graphql.bets &&
                String(queryKey[2]).toLowerCase() === address.toLowerCase()),
        }, (oldData) => {
            if (!oldData) {
                return oldData;
            }
            const newData = [...oldData];
            const bettorIndex = oldData.findIndex(({ id }) => id.split('_')[0]?.toLowerCase() === contracts.lp.address.toLowerCase());
            if (bettorIndex === -1) {
                return oldData;
            }
            const bettor = { ...newData[bettorIndex] };
            bettor.betsCount += 1;
            bettor.rawInBets = String(BigInt(bettor.rawInBets) + rawAmount);
            newData[bettorIndex] = bettor;
            return newData;
        });
    };
    return {
        updateBetCache,
        addBet,
    };
};const useBetTokenBalance = () => {
    const { appChain, betToken } = useChain();
    const { address } = useExtendedAccount();
    const formatBalance = useCallback((rawBalance) => ({
        rawBalance,
        balance: formatUnits(rawBalance, betToken.decimals),
    }), [betToken.decimals]);
    return useReadContract({
        address: betToken.address,
        abi: erc20Abi,
        functionName: 'balanceOf',
        chainId: appChain.id,
        args: [address],
        query: {
            enabled: Boolean(address),
            select: formatBalance,
        },
    });
};const useNativeBalance = () => {
    const { appChain } = useChain();
    const { address } = useExtendedAccount();
    const formatBalance = useCallback((data) => ({
        rawBalance: data.value,
        balance: formatUnits(data.value, data.decimals),
    }), []);
    return useBalance({
        chainId: appChain.id,
        address,
        query: {
            enabled: Boolean(address),
            select: formatBalance,
        },
    });
};const legacyV2LpAbi = [
    {
        'inputs': [
            { 'internalType': 'address', 'name': 'core', 'type': 'address',
            },
            { 'internalType': 'uint256', 'name': 'tokenId', 'type': 'uint256',
            },
        ], 'name': 'withdrawPayout', 'outputs': [
            { 'internalType': 'uint128', 'name': 'amount', 'type': 'uint128',
            },
        ], 'stateMutability': 'nonpayable', 'type': 'function',
    },
];
const useRedeemBet = () => {
    const { contracts, appChain } = useChain();
    const wagmiConfig = useConfig();
    const { updateBetCache } = useBetsCache();
    const { refetch: refetchBetTokenBalance } = useBetTokenBalance();
    const { refetch: refetchNativeBalance } = useNativeBalance();
    const redeemTx = useSendTransaction();
    const account = useExtendedAccount();
    const aaClient = useAAWalletClient();
    const [aaTxState, setAaTxState] = useState({ isPending: false, data: undefined, error: null });
    const receipt = useWaitForTransactionReceipt({
        hash: aaTxState.data || redeemTx.data,
        query: {
            enabled: Boolean(aaTxState.data) || Boolean(redeemTx.data),
        },
    });
    const isAAWallet = Boolean(account.isAAWallet);
    const submit = async (props) => {
        const { bets } = props;
        redeemTx.reset();
        setAaTxState({
            isPending: isAAWallet,
            data: undefined,
            error: null,
        });
        let data;
        let to;
        const { freebetContractAddress, freebetId, coreAddress, lpAddress } = bets[0];
        const isSameLp = new Set(bets.map(({ lpAddress }) => lpAddress)).size === 1;
        if (!isSameLp) {
            throw new Error('redeem can\'t be executed for multiple lp contracts');
        }
        const isBatch = bets.length > 1;
        const isV2 = lpAddress.toLowerCase() !== contracts.lp.address.toLowerCase();
        if (isBatch && isV2) {
            throw new Error('v2 redeem can\'t be executed for multiple bets');
        }
        if (freebetContractAddress && freebetId) {
            to = freebetContractAddress;
            data = encodeFunctionData({
                abi: freeBetAbi,
                functionName: 'withdrawPayout',
                args: [BigInt(freebetId)],
            });
        }
        else if (isV2) {
            to = lpAddress;
            data = encodeFunctionData({
                abi: legacyV2LpAbi,
                functionName: 'withdrawPayout',
                args: [
                    coreAddress,
                    BigInt(bets[0].tokenId),
                ],
            });
        }
        else {
            to = lpAddress;
            data = encodeFunctionData({
                abi: contracts.lp.abi,
                functionName: 'withdrawPayouts',
                args: [
                    coreAddress,
                    bets.map(({ tokenId }) => BigInt(tokenId)),
                ],
            });
        }
        let hash;
        if (isAAWallet) {
            try {
                hash = await aaClient.sendTransaction({ to, data, chain: appChain });
                setAaTxState({
                    data: hash,
                    isPending: false,
                    error: null,
                });
            }
            catch (error) {
                setAaTxState({
                    data: undefined,
                    isPending: false,
                    error,
                });
                throw error;
            }
        }
        else {
            hash = await redeemTx.sendTransactionAsync({ to, data });
        }
        const receipt = await waitForTransactionReceipt(wagmiConfig, {
            hash,
            chainId: appChain.id,
        });
        if (receipt?.status === 'reverted') {
            redeemTx.reset();
            setAaTxState({
                isPending: false,
                data: undefined,
                error: null,
            });
            throw new Error(`transaction ${receipt.transactionHash} was reverted`);
        }
        refetchBetTokenBalance();
        refetchNativeBalance();
        bets.forEach(({ tokenId }) => {
            updateBetCache(tokenId, {
                isRedeemed: true,
                isRedeemable: false,
            }, isV2);
        });
        return receipt;
    };
    return {
        isPending: redeemTx.isPending || aaTxState.isPending,
        isProcessing: receipt.isLoading,
        data: redeemTx.data || aaTxState.data,
        error: redeemTx.error || aaTxState.error,
        submit,
    };
};const simpleObjReducer$1 = (state, newState) => ({
    ...state,
    ...newState,
});
const useBet = (props) => {
    const { betAmount, slippage, deadline, affiliate, selections, odds, totalOdds, EIP712Attention, onSuccess, onError, } = props;
    const isCombo = selections.length > 1;
    // const isBatch = isCombo && typeof _betAmount === 'object'
    // const isFreeBet = Boolean(freeBet) && !isCombo && !isBatch
    // const isFreeBet = Boolean(freeBet) && !isCombo
    const isFreeBet = false;
    const account = useExtendedAccount();
    const isAAWallet = Boolean(account.isAAWallet);
    const aaClient = useAAWalletClient();
    const { appChain, contracts, betToken, api } = useChain();
    const wagmiConfig = useConfig();
    const walletClient = useWalletClient();
    const { data: betFeeData, isFetching: isRelayerFeeFetching, } = useBetFee();
    const { relayerFeeAmount: rawRelayerFeeAmount, formattedRelayerFeeAmount: relayerFeeAmount } = betFeeData || {};
    const { addBet } = useBetsCache();
    const { refetch: refetchBetTokenBalance } = useBetTokenBalance();
    const { refetch: refetchNativeBalance } = useNativeBalance();
    const [betTx, setBetTx] = useReducer(simpleObjReducer$1, { data: undefined, isPending: false });
    // const approveAddress = isLiveBet ? contracts.liveRelayer?.address : contracts.proxyFront.address
    const approveAddress = contracts.relayer.address;
    const allowanceTx = useReadContract({
        chainId: appChain.id,
        address: betToken.address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [
            account.address,
            approveAddress,
        ],
        query: {
            enabled: Boolean(account.address) && Boolean(approveAddress) && true,
        },
    });
    const approveTx = useWriteContract();
    const approveReceipt = useWaitForTransactionReceipt({
        hash: approveTx.data,
        query: {
            enabled: Boolean(approveTx.data),
        },
    });
    // const betAmount = useMemo(() => {
    //   if (typeof _betAmount === 'string') {
    //     return +_betAmount
    //   }
    //   return Object.values(_betAmount).reduce((acc, amount) => acc + +amount, 0)
    // }, [ _betAmount ])
    const isApproveRequired = useMemo(() => {
        if (!betAmount
            || typeof allowanceTx?.data === 'undefined'
            || typeof relayerFeeAmount === 'undefined') {
            return false;
        }
        const approveAmount = betAmount + +relayerFeeAmount;
        return allowanceTx.data < parseUnits(String(approveAmount), betToken.decimals);
    }, [allowanceTx.data, relayerFeeAmount, betAmount]);
    const approve = async () => {
        const hash = await approveTx.writeContractAsync({
            address: betToken.address,
            abi: erc20Abi,
            functionName: 'approve',
            args: [
                approveAddress,
                maxUint256,
            ],
        });
        await waitForTransactionReceipt(wagmiConfig, {
            hash,
            chainId: appChain.id,
        });
        allowanceTx.refetch();
    };
    const betReceipt = useWaitForTransactionReceipt({
        hash: betTx.data,
        query: {
            enabled: Boolean(betTx.data),
        },
    });
    const placeBet = async () => {
        if (!totalOdds) {
            return;
        }
        let bets = [];
        let txHash;
        setBetTx({
            data: undefined,
            isPending: true,
        });
        if (isAAWallet && aaClient) {
            await aaClient.switchChain({ id: appChain.id });
        }
        try {
            if (isFreeBet) ;
            else {
                const fixedAmount = formatToFixed(betAmount, betToken.decimals);
                const rawAmount = parseUnits(fixedAmount, betToken.decimals);
                const expiresAt = Math.floor(Date.now() / 1000) + (deadline || DEFAULT_DEADLINE);
                const fixedMinOdds = calcMindOdds({ odds: totalOdds, slippage });
                const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                const { conditionId, outcomeId } = selections[0];
                if (isAAWallet && isApproveRequired) {
                    const hash = await aaClient.sendTransaction({
                        to: betToken.address,
                        data: encodeFunctionData({
                            abi: erc20Abi,
                            functionName: 'approve',
                            args: [
                                approveAddress,
                                maxUint256,
                            ],
                        }),
                    });
                    await waitForTransactionReceipt(wagmiConfig, {
                        hash,
                        chainId: appChain.id,
                        confirmations: 1,
                    });
                }
                bets.push({
                    rawAmount,
                    selections,
                });
                const clientData = {
                    attention: EIP712Attention || 'By signing this transaction, I agree to place a bet for a live event on \'Azuro SDK Example',
                    affiliate,
                    core: contracts.core.address,
                    expiresAt,
                    chainId: appChain.id,
                    relayerFeeAmount: String(rawRelayerFeeAmount),
                    isBetSponsored: false,
                    isFeeSponsored: false,
                    isSponsoredBetReturnable: false,
                };
                let createdOrder;
                if (isCombo) {
                    const betData = {
                        account: account.address,
                        clientData,
                        amount: rawAmount,
                        minOdds: rawMinOdds,
                        nonce: String(Date.now()),
                        bets: selections,
                    };
                    const typedData = getComboBetTypedData(betData);
                    const signature = isAAWallet
                        ? await aaClient.signTypedData({ ...typedData, account: aaClient.account })
                        : await walletClient.data.signTypedData(typedData);
                    createdOrder = await createComboBet({
                        ...betData,
                        signature,
                    });
                }
                else {
                    const betData = {
                        account: account.address,
                        clientData,
                        bet: {
                            conditionId: conditionId,
                            outcomeId,
                            amount: rawAmount,
                            minOdds: rawMinOdds,
                            nonce: String(Date.now()),
                        },
                    };
                    const typedData = getBetTypedData(betData);
                    const signature = isAAWallet
                        ? await aaClient.signTypedData({ ...typedData, account: aaClient.account })
                        : await walletClient.data.signTypedData(typedData);
                    createdOrder = await createBet({
                        ...betData,
                        signature,
                    });
                }
                const { id: orderId, state: newOrderState, errorMessage, } = createdOrder;
                if (newOrderState === BetState.Created) {
                    txHash = await new Promise((res, rej) => {
                        const interval = setInterval(async () => {
                            const order = await getBet({
                                chainId: appChain.id,
                                orderId,
                            });
                            const { state, txHash, errorMessage } = order;
                            if (state === BetState.Rejected) {
                                clearInterval(interval);
                                rej(errorMessage);
                            }
                            if (txHash) {
                                clearInterval(interval);
                                res(txHash);
                            }
                        }, 1000);
                    });
                    setBetTx({
                        data: txHash,
                        isPending: false,
                    });
                }
                else {
                    throw Error(errorMessage);
                }
            }
            const receipt = await waitForTransactionReceipt(wagmiConfig, {
                hash: txHash,
                chainId: appChain.id,
            });
            if (receipt?.status === 'reverted') {
                setBetTx({
                    data: undefined,
                    isPending: false,
                });
                throw new Error(`transaction ${receipt.transactionHash} was reverted`);
            }
            refetchBetTokenBalance();
            refetchNativeBalance();
            allowanceTx.refetch();
            if (isFreeBet) ;
            if (receipt) {
                bets.forEach((bet) => {
                    addBet({
                        receipt,
                        affiliate,
                        odds,
                        bet,
                    });
                });
            }
            onSuccess?.(receipt);
        }
        catch (err) {
            setBetTx({
                isPending: false,
            });
            onError?.(err);
        }
    };
    const submit = () => {
        if (isApproveRequired && !isAAWallet) {
            return approve();
        }
        return placeBet();
    };
    return {
        submit,
        approveTx: {
            isPending: approveTx.isPending,
            isProcessing: approveReceipt.isLoading,
        },
        betTx: {
            data: betTx.data,
            receipt: betReceipt.data,
            isPending: betTx.isPending,
            isProcessing: betReceipt.isLoading,
        },
        relayerFeeAmount,
        isAllowanceLoading: allowanceTx.isLoading,
        isApproveRequired: isAAWallet ? false : isApproveRequired,
        isRelayerFeeLoading: isRelayerFeeFetching,
    };
};const useSelectionOdds = ({ selection, initialOdds }) => {
    const { conditionId, outcomeId } = selection;
    const { graphql } = useChain();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useConditionUpdates();
    const [odds, setOdds] = useState(initialOdds || 0);
    const [isFetching, setFetching] = useState(!initialOdds);
    useEffect(() => {
        if (!isSocketReady) {
            return;
        }
        subscribeToUpdates([conditionId]);
        return () => {
            unsubscribeToUpdates([conditionId]);
        };
    }, [isSocketReady, conditionId]);
    useEffect(() => {
        const unsubscribe = outcomeWatcher.subscribe(`${conditionId}-${outcomeId}`, (data) => {
            setOdds(data.odds);
        });
        return () => {
            unsubscribe();
        };
    }, [conditionId, outcomeId]);
    useEffect(() => {
        if (initialOdds) {
            return;
        }
        (async () => {
            const data = await batchFetchConditions([conditionId], graphql.feed);
            setOdds(+(data?.[conditionId]?.outcomes?.[outcomeId]?.odds || 0));
            setFetching(false);
        })();
    }, [conditionId, outcomeId, graphql.feed]);
    return {
        data: odds,
        isFetching,
    };
};const useConditionState = ({ conditionId, initialState }) => {
    const { graphql } = useChain();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useConditionUpdates();
    const [state, setState] = useState(initialState || ConditionState.Active);
    const [isFetching, setFetching] = useState(!initialState && Boolean(conditionId));
    const isLocked = state !== ConditionState.Active;
    useEffect(() => {
        if (!isSocketReady || !conditionId) {
            return;
        }
        subscribeToUpdates([conditionId]);
        return () => {
            unsubscribeToUpdates([conditionId]);
        };
    }, [isSocketReady, conditionId]);
    useEffect(() => {
        if (!conditionId) {
            return;
        }
        setState(initialState || ConditionState.Active);
        const unsubscribe = conditionWatcher.subscribe(`${conditionId}`, (data) => {
            const { state: newState } = data;
            setState(newState);
        });
        return () => {
            unsubscribe();
        };
    }, [conditionId]);
    useEffect(() => {
        if (initialState || !conditionId) {
            return;
        }
        setFetching(true);
        (async () => {
            const data = await batchFetchConditions([conditionId], graphql.feed);
            setState(data?.[conditionId]?.state || ConditionState.Active);
            setFetching(false);
        })();
    }, [conditionId, graphql.feed, initialState]);
    return {
        data: state,
        isLocked,
        isFetching,
    };
};const useGameState = ({ gameId, initialState }) => {
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useGameUpdates();
    const skip = initialState === GameState.Finished;
    const [state, setState] = useState(initialState);
    useEffect(() => {
        if (!isSocketReady || skip) {
            return;
        }
        subscribeToUpdates([gameId]);
        return () => {
            unsubscribeToUpdates([gameId]);
        };
    }, [isSocketReady, gameId, skip]);
    useEffect(() => {
        const unsubscribe = gameWathcer.subscribe(gameId, (data) => {
            const { state: newState } = data;
            setState(newState);
        });
        return () => {
            unsubscribe();
        };
    }, [gameId]);
    return {
        data: state,
    };
};const useLiveStatistics = ({ gameId, sportId, gameState, enabled = true }) => {
    const [statistics, setStatistics] = useState();
    const { subscribeToUpdates, unsubscribeToUpdates, isSocketReady } = useLiveStatisticsSocket();
    const providerId = getProviderFromId(gameId);
    const isSportAllowed = LIVE_STATISTICS_SUPPORTED_SPORTS.includes(+sportId);
    const isProviderAllowed = LIVE_STATISTICS_SUPPORTED_PROVIDERS.includes(providerId);
    const isGameInLive = gameState === GameState.Live;
    const skip = (!enabled ||
        !gameId ||
        !sportId ||
        !isSportAllowed ||
        !isProviderAllowed ||
        !isGameInLive);
    const isAvailable = isSportAllowed && isGameInLive && isProviderAllowed;
    let isFetching = !skip && !statistics && statistics !== null;
    const prevGameIdRef = useRef(gameId);
    if (prevGameIdRef.current !== gameId) {
        setStatistics(undefined);
        if (!skip) {
            isFetching = true;
        }
    }
    prevGameIdRef.current = gameId;
    useEffect(() => {
        if (!isSocketReady || skip) {
            return;
        }
        subscribeToUpdates([gameId]);
        return () => {
            unsubscribeToUpdates([gameId]);
        };
    }, [skip, gameId, isSocketReady]);
    useEffect(() => {
        if (skip) {
            return;
        }
        const unsubscribe = liveStatisticWatcher.subscribe(gameId, async (data) => {
            if (data.stats === null) {
                setStatistics(null);
            }
            else {
                setStatistics(data);
            }
        });
        return () => {
            unsubscribe();
        };
    }, [skip, gameId]);
    return {
        data: statistics,
        isFetching,
        isAvailable,
    };
};const findActiveCondition = ({ states, marketsByKey, sortedMarketKeys, activeMarketKey }) => {
    // try to find condition with Created status in active market
    let nextConditionIndex = marketsByKey[activeMarketKey].conditions.findIndex(({ conditionId }) => {
        return states[conditionId] === ConditionState.Active;
    });
    if (nextConditionIndex !== -1) {
        return {
            nextMarketKey: activeMarketKey,
            nextConditionIndex,
        };
    }
    else {
        // try to find next market and condition with Created status
        nextConditionIndex = 0;
        const nextMarketKey = sortedMarketKeys.find(marketKey => {
            return marketsByKey[marketKey].conditions.find(({ conditionId }, index) => {
                const isMatch = states[conditionId] === ConditionState.Active;
                if (isMatch) {
                    nextConditionIndex = index;
                }
                return isMatch;
            });
        });
        if (nextMarketKey) {
            return {
                nextMarketKey,
                nextConditionIndex,
            };
        }
        return {};
    }
};const useActiveMarket = ({ markets }) => {
    const { sortedMarketKeys, marketsByKey } = useMemo(() => {
        const defaultValue = {
            sortedMarketKeys: [],
            marketsByKey: {},
        };
        if (!markets?.length) {
            return defaultValue;
        }
        return markets.reduce((acc, market) => {
            const { marketKey } = market;
            acc.sortedMarketKeys.push(marketKey);
            acc.marketsByKey[marketKey] = market;
            return acc;
        }, defaultValue);
    }, [markets]);
    const [activeMarketKey, setActiveMarketKey] = useState(sortedMarketKeys[0]);
    const [activeConditionIndex, setActiveConditionIndex] = useState(0);
    const otherMarkets = useMemo(() => {
        return sortedMarketKeys.filter(key => key !== activeMarketKey);
    }, [activeMarketKey, sortedMarketKeys]);
    const conditions = useMemo(() => {
        return markets.reduce((acc, market) => {
            const { conditions } = market;
            conditions.forEach(({ conditionId, state }) => {
                acc[conditionId] = state;
            });
            return acc;
        }, {});
    }, [markets]);
    const { data: states, isFetching } = useConditionsState({
        conditionIds: Object.keys(conditions),
        initialStates: conditions,
    });
    useEffect(() => {
        if (!markets?.length) {
            return;
        }
        const activeConditionId = marketsByKey[activeMarketKey].conditions[activeConditionIndex].conditionId;
        const activeStatus = (states[activeConditionId] || ConditionState.Active);
        if (activeStatus === ConditionState.Active) {
            return;
        }
        const { nextMarketKey, nextConditionIndex } = findActiveCondition({
            states,
            marketsByKey,
            sortedMarketKeys,
            activeMarketKey,
        });
        if (nextMarketKey) {
            setActiveMarketKey(nextMarketKey);
        }
        if (nextConditionIndex) {
            setActiveConditionIndex(nextConditionIndex);
        }
    }, [states]);
    return {
        data: {
            states,
            marketsByKey,
            activeMarketKey,
            activeConditionIndex,
            otherMarkets,
            sortedMarketKeys,
        },
        isFetching,
    };
};const wrapAbi = [
    {
        'constant': false,
        'inputs': [],
        'name': 'deposit',
        'outputs': [],
        'payable': true,
        'stateMutability': 'payable',
        'type': 'function',
    },
    {
        'constant': false,
        'inputs': [
            {
                'name': 'wad',
                'type': 'uint256',
            },
        ],
        'name': 'withdraw',
        'outputs': [],
        'payable': false,
        'stateMutability': 'nonpayable',
        'type': 'function',
    },
];
const WRAP_CHAINS = [gnosis.id, base.id, baseSepolia.id];
const useWrapTokens = () => {
    const { appChain, betToken } = useChain();
    const account = useExtendedAccount();
    const aaClient = useAAWalletClient();
    const wagmiConfig = useConfig();
    const depositTx = useSendTransaction();
    const withdrawTx = useSendTransaction();
    const { refetch: refetchBetTokenBalance } = useBetTokenBalance();
    const { refetch: refetchNativeBalance } = useNativeBalance();
    const [aaDepositTxState, setAaDepositTxState] = useState({
        data: undefined,
        isPending: false,
    });
    const [aaWithdrawTxState, setAaWithdrawTxState] = useState({
        data: undefined,
        isPending: false,
    });
    const depositReceipt = useWaitForTransactionReceipt({
        hash: aaDepositTxState.data || depositTx.data,
        query: {
            enabled: Boolean(aaDepositTxState.data) || Boolean(depositTx.data),
        },
    });
    const withdrawReceipt = useWaitForTransactionReceipt({
        hash: aaWithdrawTxState.data || withdrawTx.data,
        query: {
            enabled: Boolean(aaWithdrawTxState.data) || Boolean(withdrawTx.data),
        },
    });
    const isAAWallet = Boolean(account.isAAWallet);
    const wrap = async (amount) => {
        if (!WRAP_CHAINS.includes(appChain.id)) {
            throw new Error('insufficient chain, please use Gnosis or Base');
        }
        depositTx.reset();
        setAaDepositTxState({
            isPending: isAAWallet,
            data: undefined,
        });
        const fixedAmount = formatToFixed(amount, appChain.nativeCurrency.decimals);
        const rawAmount = parseUnits(fixedAmount, appChain.nativeCurrency.decimals);
        const tx = {
            to: betToken.address,
            value: rawAmount,
            data: encodeFunctionData({
                abi: wrapAbi,
                functionName: 'deposit',
            }),
        };
        let hash;
        if (isAAWallet) {
            try {
                hash = await aaClient.sendTransaction({ ...tx, chain: appChain });
                setAaDepositTxState({
                    data: hash,
                    isPending: false,
                });
            }
            catch (error) {
                setAaDepositTxState({
                    data: undefined,
                    isPending: false,
                });
                throw error;
            }
        }
        else {
            hash = await depositTx.sendTransactionAsync(tx);
        }
        const receipt = await waitForTransactionReceipt(wagmiConfig, {
            hash,
            chainId: appChain.id,
        });
        refetchBetTokenBalance();
        refetchNativeBalance();
        return receipt;
    };
    const unwrap = async (amount) => {
        if (!WRAP_CHAINS.includes(appChain.id)) {
            throw new Error('insufficient chain, please use Gnosis or Base');
        }
        withdrawTx.reset();
        setAaWithdrawTxState({
            isPending: isAAWallet,
            data: undefined,
        });
        const fixedAmount = formatToFixed(amount, betToken.decimals);
        const rawAmount = parseUnits(fixedAmount, betToken.decimals);
        const tx = {
            to: betToken.address,
            data: encodeFunctionData({
                abi: wrapAbi,
                functionName: 'withdraw',
                args: [rawAmount],
            }),
        };
        let hash;
        if (isAAWallet) {
            try {
                hash = await aaClient.sendTransaction({ ...tx, chain: appChain });
                setAaWithdrawTxState({
                    data: hash,
                    isPending: false,
                });
            }
            catch (error) {
                setAaWithdrawTxState({
                    data: undefined,
                    isPending: false,
                });
                throw error;
            }
        }
        else {
            hash = await withdrawTx.sendTransactionAsync(tx);
        }
        const receipt = await waitForTransactionReceipt(wagmiConfig, {
            hash,
            chainId: appChain.id,
        });
        refetchBetTokenBalance();
        refetchNativeBalance();
        return receipt;
    };
    return {
        wrap,
        unwrap,
        wrapTx: {
            data: depositTx.data || aaDepositTxState.data,
            receipt: depositReceipt.data,
            isPending: depositTx.isPending || aaDepositTxState.isPending,
            isProcessing: depositReceipt.isLoading,
        },
        unwrapTx: {
            data: withdrawTx.data || aaWithdrawTxState.data,
            receipt: withdrawReceipt.data,
            isPending: withdrawTx.isPending || aaWithdrawTxState.isPending,
            isProcessing: withdrawReceipt.isLoading,
        },
    };
};const getCashouts = async (conditionIds, chainId) => {
    const data = await getPrecalculatedCashouts({
        chainId,
        conditionIds,
    });
    if (!data) {
        return undefined;
    }
    const { margin, marginMin, availables } = data;
    const cashouts = availables.reduce((acc, { conditionId, available, outcomes }) => {
        outcomes.forEach(({ outcomeId, price }) => {
            const key = `${conditionId}-${outcomeId}`;
            acc[key] = {
                conditionId,
                outcomeId: outcomeId.toString(),
                isAvailable: available,
                odds: price,
            };
        });
        return acc;
    }, {});
    return {
        margin,
        minMargin: marginMin,
        cashouts,
    };
};
const batchFetchCashouts = createBatch(getCashouts);const defaultData = {
    isAvailable: false,
    cashoutAmount: undefined,
};
const usePrecalculatedCashouts = ({ bet, query = {} }) => {
    const { tokenId, amount, outcomes, status, totalOdds } = bet;
    const { appChain, api } = useChain();
    const conditionsKey = useMemo(() => {
        return outcomes.map(({ conditionId, outcomeId }) => `${conditionId}/${outcomeId}`).join('-');
    }, [outcomes]);
    const isConditionsFromDifferentProviders = useMemo(() => {
        if (!conditionsKey) {
            return false;
        }
        const providerIds = new Set(outcomes.map(({ conditionId }) => getProviderFromId(conditionId)));
        return providerIds.size > 1;
    }, [conditionsKey]);
    const formatData = useCallback((data) => {
        if (!data) {
            return defaultData;
        }
        const { margin, minMargin, cashouts } = data;
        const isAvailable = Object.values(cashouts).every(({ isAvailable }) => isAvailable);
        let cashoutAmount = +amount * +minMargin;
        const isSameOdds = outcomes.every(({ conditionId, outcomeId, odds }) => {
            const key = `${conditionId}-${outcomeId}`;
            return +cashouts[key].odds === odds;
        });
        if (!isSameOdds) {
            const currentTotal = Object.values(cashouts).reduce((acc, { odds }) => acc + +odds, 0);
            cashoutAmount = +amount * (totalOdds / currentTotal) * +margin;
        }
        return {
            isAvailable,
            cashoutAmount,
        };
    }, [bet]);
    const { data, ...rest } = useQuery({
        queryKey: ['cashout/precalculate', api, tokenId],
        queryFn: async () => {
            const data = await batchFetchCashouts(outcomes.map(({ conditionId }) => conditionId), appChain.id);
            if (!data) {
                return data;
            }
            const cashouts = outcomes.reduce((acc, { conditionId, outcomeId }) => {
                const key = `${conditionId}-${outcomeId}`;
                const cashout = data.cashouts[key];
                acc[key] = cashout;
                return acc;
            }, {});
            return {
                ...data,
                cashouts,
            };
        },
        gcTime: 0, // disable cache
        refetchInterval: 60_000,
        refetchOnWindowFocus: false,
        select: formatData,
        ...query,
        enabled: (query.enabled &&
            !isConditionsFromDifferentProviders &&
            Boolean(bet) &&
            status === GraphBetStatus.Accepted),
    });
    return {
        data: data ?? defaultData,
        ...rest,
    };
};const simpleObjReducer = (state, newState) => ({
    ...state,
    ...newState,
});
const useCashout = (props) => {
    const { bet, EIP712Attention, onSuccess, onError, } = props;
    const { tokenId, outcomes } = bet;
    const { appChain, contracts, api, betToken } = useChain();
    const { refetch: refetchBetTokenBalance } = useBetTokenBalance();
    const { refetch: refetchNativeBalance } = useNativeBalance();
    const { updateBetCache } = useBetsCache();
    const queryClient = useQueryClient();
    const account = useExtendedAccount();
    const isAAWallet = Boolean(account.isAAWallet);
    const aaClient = useAAWalletClient();
    const walletClient = useWalletClient();
    const wagmiConfig = useConfig();
    const [cashoutTx, updateCashoutTx] = useReducer(simpleObjReducer, {
        data: undefined, isPending: false,
    });
    const updatePrecalculatedCache = () => {
        const queryKey = ['cashout/precalculate', api, tokenId];
        // set precalculate query unavailable to cashout
        queryClient.setQueryData(queryKey, (oldPrecalcCashouts) => {
            if (!oldPrecalcCashouts) {
                return oldPrecalcCashouts;
            }
            const newPrecalcCashouts = { ...oldPrecalcCashouts.cashouts };
            outcomes.forEach(({ conditionId, outcomeId }) => {
                const key = `${conditionId}-${outcomeId}`;
                newPrecalcCashouts[key] = {
                    ...newPrecalcCashouts[key],
                    isAvailable: false,
                };
            });
            return {
                ...oldPrecalcCashouts,
                cashouts: newPrecalcCashouts,
            };
        });
    };
    const calculationQuery = useQuery({
        queryKey: ['cashout/calculate', api, account.address?.toLowerCase(), tokenId],
        queryFn: () => getCalculatedCashout({
            chainId: appChain.id,
            account: account.address,
            graphBetId: `${contracts.core.address.toLowerCase()}_${tokenId}`,
        }),
        refetchOnWindowFocus: false,
        retry: () => {
            updatePrecalculatedCache();
            return false; // disable retries on error
        },
        gcTime: 0, // disable cache
        enabled: (!!account.address),
    });
    const { data: calculation } = calculationQuery;
    const { calculationId, cashoutOdds, expiredAt, approveExpiredAt } = calculation || {};
    const isCashoutAvailable = (Boolean(calculationId));
    const allowanceTx = useReadContract({
        chainId: appChain.id,
        address: contracts.azuroBet.address,
        abi: contracts.azuroBet.abi,
        functionName: 'isApprovedForAll',
        args: [
            account.address,
            contracts.cashout?.address,
        ],
        query: {
            enabled: (Boolean(account.address) &&
                Boolean(contracts.cashout?.address) &&
                isCashoutAvailable),
        },
    });
    const isApproveRequired = (!allowanceTx.isLoading &&
        !allowanceTx.data);
    const approveTx = useWriteContract();
    const approveReceipt = useWaitForTransactionReceipt({
        hash: approveTx.data,
    });
    const cashoutReceipt = useWaitForTransactionReceipt({
        hash: cashoutTx.data,
    });
    const approve = async () => {
        const hash = await approveTx.writeContractAsync({
            address: contracts.azuroBet.address,
            abi: contracts.azuroBet.abi,
            functionName: 'setApprovalForAll',
            args: [
                contracts.cashout?.address,
                true,
            ],
        });
        await waitForTransactionReceipt(wagmiConfig, {
            hash,
            chainId: appChain.id,
        });
        allowanceTx.refetch();
    };
    const cashout = async () => {
        try {
            if (!isCashoutAvailable) {
                throw new Error('cashout unavailable');
            }
            updateCashoutTx({
                data: undefined,
                isPending: true,
            });
            // switch chain and approve
            if (isAAWallet && aaClient) {
                await aaClient.switchChain({ id: appChain.id });
                if (isApproveRequired) {
                    const hash = await aaClient.sendTransaction({
                        to: contracts.azuroBet.address,
                        data: encodeFunctionData({
                            abi: contracts.azuroBet.abi,
                            functionName: 'setApprovalForAll',
                            args: [
                                contracts.cashout?.address,
                                true,
                            ],
                        }),
                    });
                    await waitForTransactionReceipt(wagmiConfig, {
                        hash,
                        chainId: appChain.id,
                    });
                }
            }
            const attention = EIP712Attention || 'By signing this transaction, I agree to cash out on \'Azuro SDK Example';
            const typedData = getCashoutTypedData({
                chainId: appChain.id,
                account: account.address,
                attention,
                tokenId,
                cashoutOdds: cashoutOdds,
                expiredAt: expiredAt,
            });
            const signature = isAAWallet
                ? await aaClient.signTypedData({ ...typedData, account: aaClient.account })
                : await walletClient.data.signTypedData(typedData);
            if (Date.now() >= approveExpiredAt) {
                throw new Error('expired call');
            }
            const createdCashout = await createCashout({
                chainId: appChain.id,
                calculationId: calculationId,
                attention,
                signature,
            });
            const { id: orderId, state: newOrderState, errorMessage, } = createdCashout;
            let txHash;
            if (newOrderState && newOrderState !== CashoutState.Rejected) {
                txHash = await new Promise((res, rej) => {
                    const interval = setInterval(async () => {
                        const order = await getCashout({
                            chainId: appChain.id,
                            orderId,
                        });
                        const { state, txHash, errorMessage } = order;
                        if (state === CashoutState.Rejected) {
                            clearInterval(interval);
                            rej(errorMessage);
                        }
                        if (txHash) {
                            clearInterval(interval);
                            res(txHash);
                        }
                    }, 1000);
                });
            }
            else {
                throw Error(errorMessage);
            }
            const receipt = await waitForTransactionReceipt(wagmiConfig, {
                hash: txHash,
                chainId: appChain.id,
            });
            if (receipt?.status === 'reverted') {
                updateCashoutTx({
                    isPending: false,
                    data: undefined,
                });
                throw new Error(`transaction ${receipt.transactionHash} was reverted`);
            }
            const receiptArgs = getEventArgsFromTxReceipt({
                receipt,
                eventName: 'Transfer',
                abi: erc20Abi,
                params: {
                    to: account.address,
                },
            });
            refetchBetTokenBalance();
            refetchNativeBalance();
            allowanceTx.refetch();
            updatePrecalculatedCache();
            updateBetCache(tokenId, {
                isCashedOut: true,
                cashout: formatUnits(receiptArgs?.value || 0n, betToken.decimals),
            });
            onSuccess?.(receipt);
        }
        catch (err) {
            updateCashoutTx({
                isPending: false,
            });
            onError?.(err);
        }
    };
    const submit = () => {
        if (isApproveRequired && !isAAWallet) {
            return approve();
        }
        return cashout();
    };
    return {
        submit,
        calculationQuery,
        approveTx: {
            isPending: approveTx.isPending,
            isProcessing: approveReceipt.isLoading,
        },
        cashoutTx: {
            data: cashoutTx.data,
            receipt: cashoutReceipt.data,
            isPending: cashoutTx.isPending,
            isProcessing: cashoutReceipt.isLoading,
        },
        isAllowanceFetching: allowanceTx.isLoading,
        isCashoutAvailable,
        isApproveRequired,
    };
};const useWaveLevels = ({ waveId } = { waveId: 'active' }) => {
    const { appChain, api } = useChain();
    const queryFn = () => (getWaveLevels({
        chainId: appChain.id,
        waveId,
    }));
    return useQuery({
        queryKey: ['wave/levels', waveId, api],
        queryFn,
        refetchOnWindowFocus: false,
    });
};const useWaveStats = ({ account, waveId = 'active' }) => {
    const { appChain, api } = useChain();
    const queryFn = async () => {
        const data = await getWaveStats({
            account,
            waveId,
            chainId: appChain.id,
        });
        if (!data) {
            return data;
        }
        const { address, levelActivated, ...rest } = data;
        return {
            ...rest,
            isActivated: levelActivated,
        };
    };
    return useQuery({
        queryKey: ['wave/stats', waveId, api, account?.toLowerCase()],
        queryFn,
        refetchOnWindowFocus: false,
        enabled: Boolean(account),
    });
};const useWavePeriods = ({ waveId } = { waveId: 'active' }) => {
    const { appChain, api } = useChain();
    const queryFn = async () => {
        const data = await getWavePeriods({
            waveId,
            chainId: appChain.id,
        });
        if (!data) {
            return data;
        }
        return [...data].reverse().map(({ id, startsAt, endsAt, totalPoints }, index) => {
            const fromTimestamp = new Date(startsAt).getTime();
            const toTimestamp = new Date(endsAt).getTime() - 1000;
            return {
                id,
                startsAt: Math.floor(fromTimestamp / 1000),
                endsAt: Math.floor(toTimestamp / 1000),
                totalPoints,
                isBonusPreCalc: !index,
            };
        });
    };
    return useQuery({
        queryKey: ['wave/periods', waveId, api],
        queryFn,
        refetchOnWindowFocus: false,
    });
};const useWaveLeaderBoard = ({ waveId = 'active', account, startsAt, enabled }) => {
    const { appChain, api } = useChain();
    const queryFn = () => (getWaveLeaderBoard({
        waveId,
        account,
        startsAt,
        chainId: appChain.id,
    }));
    return useQuery({
        queryKey: ['wave/leaderboard', waveId, api, account?.toLowerCase(), startsAt],
        queryFn,
        refetchOnWindowFocus: false,
        enabled,
    });
};const useWaveActivation = ({ account, waveId = 'active' }) => {
    const queryClient = useQueryClient();
    const { appChain, api } = useChain();
    const mutationFn = () => (activateWave({
        account,
        waveId,
        chainId: appChain.id,
    }));
    const { mutate, mutateAsync, isPending } = useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['wave/stats', waveId, api, account?.toLowerCase()] });
            queryClient.invalidateQueries({ queryKey: ['wave/leaderboard', waveId, api, account?.toLowerCase()] });
        },
    });
    return {
        activate: mutate,
        activateAsync: mutateAsync,
        isPending,
    };
};export{AzuroSDKProvider,BaseBetslipContext,BetType,BetslipDisableReason,BetslipProvider,ChainProvider,ConditionUpdatesProvider,DetailedBetslipContext,FeedSocketProvider,GameUpdatesProvider,LIVE_STATISTICS_SUPPORTED_PROVIDERS,LIVE_STATISTICS_SUPPORTED_SPORTS,LiveContext,LiveProvider,LiveStatisticsSocketProvider,SportHub,WRAP_CHAINS,cookieKeys,localStorageKeys,useActiveConditions,useActiveMarket,useActiveMarkets,useBaseBetslip,useBet,useBetFee,useBetTokenBalance,useBets,useBetsSummary,useBetsSummaryBySelection,useCashout,useChain,useConditionState,useConditions,useConditionsState,useDetailedBetslip,useGame,useGameState,useGames,useLegacyBets,useLive,useLiveStatistics,useMaxBet,useNativeBalance,useNavigation,useOdds,usePrecalculatedCashouts,useRedeemBet,useResolvedMarkets,useSelectionOdds,useSports,useSportsNavigation,useWaveActivation,useWaveLeaderBoard,useWaveLevels,useWavePeriods,useWaveStats,useWrapTokens};